/*============================================================
   dbakers Heart Cake Builder JS — Wizard Style
   Prefix: dhb-
   Supports all 18 heart cake variants via metafields
   Matches signature builder cart patterns (dbsb-)

   Updated 2026-05-01: appended chat widget opener + color
   guide accordion handlers (ported from designer builder).

   Updated 2026-05-25: dietary step now comes BEFORE flavor.
   Flavors are filtered against the customer's dietary selection
   so incompatible flavors are hidden silently. Filter re-applies
   if the customer goes back to the diet step and changes their
   selection (e.g. from "Nut Allergy" back to "No restrictions").
   ============================================================ */
(function () {
'use strict';
var VARIANT_IDS = {
sparklers:       '31139639754799',
rainbowCandles:  '52437652013372',
cakeServer:      '46434309144892',
bow:             '46066014552380',
coldPack:        '41195387748399',
glutenFree:      '41210593968175'
  };
/* ── Cloudinary upload (matches designer builder) ──
   Cropped + heart-masked PNGs upload here at add-to-cart time so the
   bakery gets a clickable URL in the order properties (not just a
   filename). 8s timeout + filename fallback if Cloudinary is slow. */
var CLOUDINARY_CLOUD  = 'dlocffoio';
var CLOUDINARY_PRESET = 'dbakers_cake_photos';
var CLOUDINARY_URL    = 'https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/image/upload';
var cfg = window.dhbProduct || {};
var NO_GF_FLAVORS = ['Red Velvet & Chocolate', 'Red Velvet (Original)'];
var NUT_FLAVORS = ['▪️ Nutella Vanilla', '▪️Carrot Cake with Dulce de Leche', '▪️Carrot Cake (Original)', '✔️ Marble Cake: Nutella Fudge', '✨ Pistachio Raspberry'];
var TEXT_FONTS = {
fondant: "'CooperBlack', serif",
cursive: "'SweetCharm', cursive",
block:   "'PleaseWriteMeASong', system-ui"
  };
var CHAR_LIMITS = {
fondant: { mini: { l1: 5, l2: 4 }, medium: { l1: 7, l2: 6 }, large: { l1: 9, l2: 8 } },
cursive: { mini: 15, medium: 25, large: 40 },
block:   { mini: 15, medium: 25, large: 40 }
  };
var CHERRY_PRICES = {
'Fake cherries': 0, 'Maraschino cherries': 0,
'Gold fake cherries': 10, 'Silver fake cherries': 10,
'Rose Gold fake cherries': 10, 'No cherries': 0
  };
/* ── Dynamic price helper — reads from Shopify via dhbOptionPrices ── */
function optPrice(name) {
var p = window.dhbOptionPrices && window.dhbOptionPrices[name];
return p ? p / 100 : 0;
  }
function candlePrice(name) {
var p = window.dhbCandlePrices && window.dhbCandlePrices[name];
return p ? p / 100 : 0;
  }
function metallicPrice(name) {
var p = window.dhbMetallicPrices && window.dhbMetallicPrices[name];
return p ? p / 100 : 0;
  }
/* Single-variant product price helpers — fall back to sensible defaults
   if the Liquid var isn't set (defensive — shouldn't happen in prod). */
function rainbowCandlePrice()  { return (window.dhbRainbowPrice  || 499)  / 100; }
function sparklerPrice()       { return (window.dhbSparklerPrice || 1199) / 100; }
function glutenFreePrice()     { return (window.dhbGlutenFreePrice || 1500) / 100; }
var state = {
currentStep: 1, totalSteps: 0, steps: [],
hasInitialized: false,
variantId: null, basePrice: 0, sizeName: '', sizeKey: '',
flavor: '', flavorExtra: 0, flavorVariantTitle: '', noGF: false, hasNuts: false,
diet: { gf: false, nut: false }, dietExtra: 0, nutAcked: false, gfAcked: false,
colors: {}, customColorPrices: {}, presetColor: '',
ribbonColor: '',
cherry: '', cherryPrice: 0,
pipingColor: '', pipingExtra: 0,
decoColor: 'Gold', pearlChoice: '',
sprinkle: { key: '', name: '', price: 0 },
textStyle: '', letterColor: '', customLetterPrice: 0,
msgLine1: '', msgLine2: '', msgText: '',
burnAwayTop: 'calendar', burnMonth: '', burnDay: '',
burnAwayTopFileName: '', burnAwayTopFileNameCropData: null, burnAwayTopFileNameObjectUrl: null,
burnAwayTopCropper: null, burnAwayTopUrl: '',
revealType: '', revealImageName: '', revealImageNameCropData: null, revealImageNameObjectUrl: null,
revealImageCropper: null, revealImageUrl: '', revealImageUpcharge: 0,
photoFileName: '', photoFileNameCropData: null, photoFileNameObjectUrl: null,
photoCropper: null, photoUrl: '',
addons: {
candles: {
sel: false,
/* New multi-select model — each type is independently toggleable
   with its own config. Customer can pick Rainbow + Sparklers
   together; pricing sums them up; cart adds one line item per
   active type. */
types: {
rainbow:   { active: false },
metallic:  { active: false, color: '' },
number:    { active: false, color: '', number: '' },
sparklers: { active: false }
        }
      },
gift:    { sel: false, text: '' }
    },
extras: {
bow:         { sel: false, price: 5.25 },
server:      { sel: false, price: 2.00 },
coldpack:    { sel: false, price: 3.00 },
addCherries: { sel: false, type: '', price: 0 },
addBow:      { sel: false, color: '', price: 10 },
addGlitter:  { sel: false, price: 20 }
    }
  };
/* ── Init ── */
function init() {
if (!document.getElementById('dhb-root')) return;
/* Sync standard extra prices from Shopify (live products) instead of
   relying on hardcoded fallbacks. If Shopify changes the price of the
   Cake Server, Cold Pack, or XL Gold Bow, the builder follows. */
if (window.dhbServerPrice)   state.extras.server.price   = window.dhbServerPrice / 100;
if (window.dhbColdPackPrice) state.extras.coldpack.price = window.dhbColdPackPrice / 100;
if (window.dhbBowPrice)      state.extras.bow.price      = window.dhbBowPrice / 100;
/* Mini cakes have no size step — read variant info from the hidden
   input emitted by liquid so cart submission and pricing work. */
if (cfg.isMini) {
var miniInput = document.getElementById('dhb-variant-id');
if (miniInput) {
state.variantId = miniInput.value;
state.basePrice = parseFloat(miniInput.dataset.variantPrice || 0) / 100;
/* Display label is hardcoded for mini cakes — Shopify variant title
   is usually "Default Title" since these products have no variants,
   and we don't want that leaking into the price bar / summary. */
state.sizeName  = '4″ Mini Heart Cake';
state.sizeKey   = 'mini_heart';
      }
    }
buildStepList();
bindAll();
loadFonts();
/* On page load, slot 1's "Like image" swatch is pre-selected via the
   markup. Sync the accordion header swatch to match — otherwise it
   shows an empty dashed "+" circle, which is misleading. */
initSlotHeaders();
/* Cute Sprinkle Sweetheart only allows fondant. Pre-set the state
   AND trigger the same JS path as if the customer had tapped the
   fondant card so the message inputs show up. The card is already
   pre-marked .is-selected in liquid markup. */
if (cfg.forceFondantOnly) {
state.textStyle = 'fondant';
var msgFields = document.getElementById('dhb-msg-fields');
if (msgFields) msgFields.className = 'dhb-msg-fields';
var fondantFields = document.getElementById('dhb-fondant-fields');
if (fondantFields) fondantFields.classList.remove('dhb-hidden');
var blockFields = document.getElementById('dhb-block-fields');
if (blockFields) blockFields.classList.add('dhb-hidden');
    }
/* Size is no longer preselected — customer must actively tap Medium
   or Large to commit. The price bar shows "Pick a size" until they do. */
showStep(1);
/* Mark builder as initialized — auto-scroll on step change only
   activates AFTER this point. Prevents the page from yanking the
   customer down to the builder on initial page load. */
state.hasInitialized = true;
  }
/* Init runs immediately on DOMContentLoaded — the previous 300ms delay
   was a font race-condition workaround that's no longer needed since
   loadFonts() is async and the builder UI doesn't depend on fonts being
   ready at init time. Saves ~300ms on first paint. */
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
/* ── Step list ── */
function buildStepList() {
var steps = [];
/* Mini cakes start with a size primer instead of a picker. Sets
   expectations clearly to prevent "I thought it would be bigger"
   complaints — customer must tap Continue to acknowledge. */
if (cfg.isMini) steps.push('mini-intro');
else steps.push('size');
/* EDIT 1: Diet now comes BEFORE flavor so customers declare any
   dietary restrictions first, and the flavor step filters out
   incompatible flavors based on their selection. */
steps.push('diet', 'flavor');
/* Cute Sprinkle: pick the sprinkle mix BEFORE the color step. The
   sprinkle choice is foundational to the cake's look (not a finishing
   touch), so it goes early. Hardcoded handle check until we promote
   this to a metafield (dbakers.has_sprinkle_style_pick). */
if (cfg.hasCuteSprinkleStyle) steps.push('cute-sprinkle-style');
if (cfg.hasPresetColors) steps.push('presetcolor');
else if (cfg.hasColors)  steps.push('color');
if (cfg.hasRibbonColor)  steps.push('ribbon');
if (cfg.hasCherries)     steps.push('cherries');
if (cfg.hasBurnAway)     { steps.push('burnaway-top'); steps.push('burnaway-reveal'); }
else if (cfg.hasMessage) steps.push('message');
if (cfg.hasPhotoUpload && !cfg.hasBurnAway) steps.push('photo');
/* Decoration color — celestial / metallic-detail cakes can swap
   gold for silver or white. Free, just a property on the cake. */
if (cfg.hasDecorationColor) steps.push('decocolor');
/* Sprinkles step — Photo Sweetheart and other has_sprinkles cakes.
   Comes after photo (or after message for non-photo cakes) since
   sprinkles feel like a finishing touch on top of the cake design. */
if (cfg.hasSprinkles) steps.push('sprinkles');
/* "Make it pretty" — optional decoratives (bow / cherries / glitter as addons).
   Only shown when at least one is available on this product. */
if (cfg.canAddCherries || cfg.canAddBow || cfg.canAddGlitter) steps.push('decoratives');
steps.push('review');
state.steps      = steps;
state.totalSteps = steps.length;
  }
function stepIndex(id)  { return state.steps.indexOf(id); }
function currentStepId(){ return state.steps[state.currentStep - 1]; }
function stepLabel(id) {
var m = { size:'Size', 'mini-intro':'Size', flavor:'Flavor', diet:'Dietary', color:'Color', presetcolor:'Color',
ribbon:'Ribbon color', cherries:'Cherries', 'cute-sprinkle-style':'Sprinkles',
'burnaway-top':'Burn away top', 'burnaway-reveal':'What\u2019s underneath',
message:'Message', photo:'Photo', decocolor:'Detail color', sprinkles:'Sprinkles', decoratives:'Make it pretty', review:'Review' };
return m[id] || id;
  }
/* ── Fonts ── */
function loadFonts() {
    [['CooperBlack', window.dhbFontCooper, 'opentype'],
     ['SweetCharm',  window.dhbFontSweet,  'opentype'],
     ['PleaseWriteMeASong', window.dhbFontPlease, 'truetype']
    ].forEach(function(f) {
if (!f[1]) return;
var s = document.createElement('style');
s.textContent = "@font-face{font-family:'" + f[0] + "';src:url('" + f[1] + "') format('" + f[2] + "');}";
document.head.appendChild(s);
    });
  }
/* ── Show step ── */
function showStep(n) {
state.currentStep = n;
var id = currentStepId();
document.querySelectorAll('.dhb-step').forEach(function(el) { el.classList.remove('is-active'); });
var el = document.getElementById('dhb-step-' + id);
if (el) el.classList.add('is-active');
var ps = document.getElementById('dhb-prog-step');
var pt = document.getElementById('dhb-prog-title');
var pf = document.getElementById('dhb-prog-fill');
if (ps) ps.textContent = 'Step ' + n + ' of ' + state.totalSteps;
if (pt) pt.textContent = stepLabel(id);
if (pf) pf.style.width = Math.round((n / state.totalSteps) * 100) + '%';
/* Announce step change to screen readers */
var announce = document.getElementById('dhb-step-announce');
if (announce) announce.textContent = 'Step ' + n + ' of ' + state.totalSteps + ': ' + stepLabel(id);
var bb = document.getElementById('dhb-btn-back');
var bn = document.getElementById('dhb-btn-next');
var ba = document.getElementById('dhb-btn-atc');
var isLast = (n === state.totalSteps);
if (bb) bb.className = n > 1 ? 'dhb-btn-back' : 'dhb-btn-back dhb-hidden';
if (bn) bn.className = isLast ? 'dhb-btn-next dhb-hidden' : 'dhb-btn-next';
if (ba) ba.className = isLast ? 'dhb-btn-atc' : 'dhb-btn-atc dhb-hidden';
if (id === 'diet')   refreshDietStep();
/* EDIT 4: Re-filter flavors every time the customer enters the
   flavor step. Catches both forward navigation (after diet) and
   back navigation (e.g. customer changed Nut Allergy → No restrictions
   then returned to flavor). */
if (id === 'flavor') filterFlavors();
if (id === 'review') populateSummary();
updatePrice();
/* ── Smart auto-scroll on step change ──
   When the step changes, scroll the progress bar ("Step X of Y") to
   the top of the viewport — but ONLY if it's not already visible.
   This handles every advancement path: Next button, Back button, Edit
   links from the review summary, and auto-advance (e.g. size pick).
   Customers already looking at the right place aren't disturbed.
   Skipped on the very first showStep(1) at page load (gated by
   state.hasInitialized) so the page doesn't yank the customer down
   to the builder when they first land. */
if (!state.hasInitialized) return;
setTimeout(function() {
var anchor = document.getElementById('dhb-prog-step');
if (!anchor || !anchor.getBoundingClientRect) return;
var rect = anchor.getBoundingClientRect();
var viewportH = window.innerHeight || document.documentElement.clientHeight;
/* ── Detect sticky nav height ──
   The dbakers theme nav lives in a `.dbn-wrap` element that's
   position:fixed at the top of the page (32px top bar + 64px nav
   on desktop, 32px + 56px on mobile). We measure its actual current
   height instead of hardcoding values, so any future changes to the
   nav height (logo size, hidden bars, etc.) are picked up automatically.
   Falls back to generic Shopify header selectors, then a 96px estimate. */
var stickyHeight = 0;
var nav = document.querySelector('.dbn-wrap');
if (nav) {
stickyHeight = nav.offsetHeight;
      } else {
/* Theme might use a different nav. Try common Shopify header
   patterns. We only count an element if it's actually positioned
   fixed/sticky at the top — otherwise it's just a regular element
   that happens to match the selector. */
var fallbackSelectors = ['header[role="banner"]', '.shopify-section-header', '.site-header', 'header'];
for (var hi = 0; hi < fallbackSelectors.length; hi++) {
var el = document.querySelector(fallbackSelectors[hi]);
if (!el) continue;
var elStyle = window.getComputedStyle(el);
var elRect = el.getBoundingClientRect();
var isStuck = (elStyle.position === 'fixed' || elStyle.position === 'sticky') && elRect.top <= 1 && elRect.height > 0;
if (isStuck) { stickyHeight = el.offsetHeight; break; }
        }
/* Last-resort estimate matches dbakers nav default (96px desktop). */
if (stickyHeight === 0) stickyHeight = 96;
      }
/* ── "Already visible" check ──
   The progress bar counts as visible if it's BELOW the sticky header
   (rect.top > stickyHeight) AND not pushed too far down (within 60%
   of viewport). If the bar is currently hidden behind the header,
   that's not visible — scroll it down. */
var topMargin = 12; /* small breathing room below the sticky header */
var minVisibleY = stickyHeight + topMargin;
var maxVisibleY = viewportH * 0.6;
var visible = rect.top >= minVisibleY && rect.top <= maxVisibleY;
if (visible) return;
/* Scroll so the progress bar sits 12px below the sticky header */
var targetY = window.pageYOffset + rect.top - stickyHeight - topMargin;
window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
    }, 60);
  }
function goNext() {
var id = currentStepId();
/* ── Mandatory step validation ── */
if (id === 'size' && !state.variantId) {
showStepError('dhb-step-size', '⚠️ Please choose a size before continuing.');
return;
    }
if (id === 'flavor' && !state.flavor) {
showStepError('dhb-step-flavor', '⚠️ Please choose a flavor before continuing.');
return;
    }
if (id === 'diet' && state.diet.nut && !state.nutAcked) {
showStepError('dhb-step-diet', '⚠️ Please acknowledge the nut allergy notice to continue.');
return;
    }
if (id === 'diet' && state.diet.gf && !state.gfAcked) {
showStepError('dhb-step-diet', '⚠️ Please acknowledge the gluten notice to continue.');
return;
    }
if (id === 'color') {
for (var ci = 1; ci <= (cfg.colorCount || 1); ci++) {
if (!state.colors[ci]) {
showStepError('dhb-step-color', '⚠️ Please choose ' + (cfg.colorCount > 1 ? 'all colors' : 'a color') + ' before continuing.');
return;
        }
      }
    }
if (id === 'presetcolor' && !state.presetColor) {
showStepError('dhb-step-presetcolor', '⚠️ Please choose a color combination before continuing.');
return;
    }
if (id === 'ribbon' && !state.ribbonColor) {
showStepError('dhb-step-ribbon', '⚠️ Please choose a ribbon color before continuing.');
return;
    }
if (id === 'cherries' && !state.cherry) {
showStepError('dhb-step-cherries', '⚠️ Please choose a cherry option before continuing.');
return;
    }
if (id === 'cute-sprinkle-style' && !state.sprinkle.key) {
showStepError('dhb-step-cute-sprinkle-style', '⚠️ Please choose your sprinkle style before continuing.');
return;
    }
if (id === 'message') {
if (!state.textStyle) {
showStepError('dhb-step-message', '⚠️ Please choose a text style before continuing.');
return;
      }
if (state.textStyle !== 'none') {
if (!state.letterColor && cfg.hasLetterColors && !cfg.letterColorMatchesColor && !cfg.hasRibbonColor) {
showStepError('dhb-step-message', '⚠️ Please choose a letter color before continuing.');
return;
        }
if (state.textStyle === 'fondant' && !state.msgLine1.trim()) {
showStepError('dhb-step-message', '⚠️ Please enter your message before continuing.');
return;
        }
if (state.textStyle !== 'fondant' && !state.msgText.trim()) {
showStepError('dhb-step-message', '⚠️ Please enter your message before continuing.');
return;
        }
      }
    }
if (id === 'burnaway-top') {
if (!state.burnAwayTop) { showStepError('dhb-step-burnaway-top', '⚠️ Please choose what burns away on top.'); return; }
if (state.burnAwayTop === 'calendar' && (!state.burnMonth || !state.burnDay)) { showStepError('dhb-step-burnaway-top', '⚠️ Please enter the month and day to circle.'); return; }
if (state.burnAwayTop === 'calendar' && state.burnDay) {
/* Validate day is in valid range for the selected month.
   Days per month: Jan=31, Feb=29 (leap-friendly), Mar=31, Apr=30, May=31, Jun=30, Jul=31, Aug=31, Sep=30, Oct=31, Nov=30, Dec=31 */
var maxDays = { January: 31, February: 29, March: 31, April: 30, May: 31, June: 30, July: 31, August: 31, September: 30, October: 31, November: 30, December: 31 };
var dayNum = parseInt(state.burnDay, 10);
var max = maxDays[state.burnMonth] || 31;
if (isNaN(dayNum) || dayNum < 1 || dayNum > max) {
showStepError('dhb-step-burnaway-top', '⚠️ Please enter a valid day (1–' + max + ' for ' + state.burnMonth + ').');
return;
        }
      }
if (state.burnAwayTop === 'image' && !state.burnAwayTopFileName) { showStepError('dhb-step-burnaway-top', '⚠️ Please upload your top image.'); return; }
    }
if (id === 'burnaway-reveal') {
if (!state.revealType) { showStepError('dhb-step-burnaway-reveal', '⚠️ Please choose what\u2019s underneath.'); return; }
if (state.revealType === 'fondant' && !state.msgLine1.trim()) { showStepError('dhb-step-burnaway-reveal', '⚠️ Please enter your reveal message.'); return; }
if (state.revealType === 'image' && !state.revealImageName) { showStepError('dhb-step-burnaway-reveal', '⚠️ Please upload your reveal photo.'); return; }
    }
if (id === 'photo' && cfg.hasPhotoUpload && !state.photoFileName) {
showStepError('dhb-step-photo', '⚠️ Please upload your photo before continuing.');
return;
    }
if (id === 'sprinkles' && !state.sprinkle.key) {
showStepError('dhb-step-sprinkles', '⚠️ Please choose a sprinkle option before continuing.');
return;
    }
if (state.currentStep < state.totalSteps) showStep(state.currentStep + 1);
  }
function goBack() {
if (state.currentStep > 1) showStep(state.currentStep - 1);
  }
function goToStep(id) { var i = stepIndex(id); if (i > -1) showStep(i + 1); }
function showStepError(stepId, msg) {
var errId = stepId + '-err';
var err = document.getElementById(errId);
if (!err) {
err = document.createElement('div');
err.id = errId;
err.style.cssText = 'color:#b91c1c;font-size:13px;font-weight:600;padding:10px 12px;background:#fff5f5;border:1px solid #e57373;border-radius:8px;margin-top:10px;';
var step = document.getElementById(stepId);
if (step) step.appendChild(err);
    }
err.textContent = msg;
err.style.display = 'block';
setTimeout(function() { if (err) err.style.display = 'none'; }, 3000);
  }
/* ── Price ── */
function calcTotal() {
var t = state.basePrice + state.flavorExtra + state.dietExtra + state.revealImageUpcharge;
/* Custom color fees — dynamic from Shopify */
var customColorCount = Object.keys(state.customColorPrices).filter(function(k) { return state.customColorPrices[k] > 0; }).length;
if (customColorCount > 0) t += optPrice('Custom color') * customColorCount;
/* Custom letter color */
if (state.customLetterPrice > 0) t += optPrice('Custom letter color') || 5;
/* Custom piping color */
if (state.pipingExtra > 0) t += optPrice('Custom piping color') || 5;
/* Built-in cherry upcharge — gated on cfg.hasCherries so a stray
   state.cherryPrice (from a future binder bug) can never silently
   inflate the total on a cake without a built-in cherry step. */
if (cfg.hasCherries) t += state.cherryPrice;
/* Sprinkles — most are included (price 0), pearls are +$10 */
if (state.sprinkle.price > 0) t += state.sprinkle.price;
/* Candles — sum the price of every active type. All prices read live
   from Shopify so changes in the admin auto-flow to the builder. */
if (state.addons.candles.sel) {
var ctypes = state.addons.candles.types;
if (ctypes.rainbow.active)   t += rainbowCandlePrice();
if (ctypes.sparklers.active) t += sparklerPrice();
if (ctypes.metallic.active && ctypes.metallic.color) {
t += metallicPrice(ctypes.metallic.color) || 4.99;
      } else if (ctypes.metallic.active) {
/* Color not yet picked — show base metallic price as a placeholder */
t += 4.99;
      }
if (ctypes.number.active && ctypes.number.color) {
var digits = ctypes.number.number ? String(ctypes.number.number).replace(/\D/g, '').length : 0;
t += digits > 0 ? digits * (candlePrice(ctypes.number.color) || 2) : 0;
      }
    }
/* Standard extras */
if (state.extras.bow.sel)         t += state.extras.bow.price;
if (state.extras.server.sel)      t += state.extras.server.price;
if (state.extras.coldpack.sel)    t += state.extras.coldpack.price;
/* Add-on extras — dynamic from Shopify */
if (state.extras.addCherries.sel) {
var cherryVar = state.extras.addCherries.price >= 20 ? 'Add cherries — Metallic' : 'Add cherries — Fake or Maraschino';
t += optPrice(cherryVar) || state.extras.addCherries.price;
    }
if (state.extras.addBow.sel)     t += optPrice('Add bows') || 10;
if (state.extras.addGlitter.sel) t += optPrice('Add iridescent glitter') || 20;
return t;
  }
function updatePrice() {
var total = calcTotal();
var lbl = document.getElementById('dhb-price-label');
var val = document.getElementById('dhb-price-val');
if (lbl) lbl.textContent = state.sizeName || 'Pick a size';
if (val) val.textContent = state.basePrice > 0 ? '$' + total.toFixed(2) : '—';
  }
/* ── tap helper ──
   Distinguishes a real tap from a scroll/swipe by tracking touch
   movement. If the finger moves more than 10px between touchstart
   and touchend, treat it as a scroll and don't fire the handler.
   Without this guard, scrolling a long flavor list on mobile fires
   selection on whatever card the finger happens to lift off of. */
function tap(el, fn) {
if (!el) return;
var startX = 0, startY = 0, moved = false;
el.addEventListener('touchstart', function(e) {
if (!e.touches || !e.touches[0]) return;
startX = e.touches[0].clientX;
startY = e.touches[0].clientY;
moved = false;
    }, { passive: true });
el.addEventListener('touchmove', function(e) {
if (moved || !e.touches || !e.touches[0]) return;
var dx = Math.abs(e.touches[0].clientX - startX);
var dy = Math.abs(e.touches[0].clientY - startY);
if (dx > 10 || dy > 10) moved = true;
    }, { passive: true });
el.addEventListener('touchend', function(e) {
if (moved) return; /* it was a scroll, not a tap */
e.preventDefault();
fn(e);
    }, { passive: false });
el.addEventListener('click', fn);
  }
/* Cart error banner — replaces native alert() for cart/add.js
   failures and validation messages. Inline UI is far better UX:
   doesn't block the page, stays in builder context, dismissible. */
function showCartError(msg) {
var banner = document.getElementById('dhb-cart-error');
var msgEl  = document.getElementById('dhb-cart-error-msg');
if (!banner || !msgEl) return;
msgEl.textContent = msg || 'Something went wrong adding to cart. Please try again.';
banner.classList.add('is-visible');
banner.setAttribute('aria-hidden', 'false');
banner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
function hideCartError() {
var banner = document.getElementById('dhb-cart-error');
if (!banner) return;
banner.classList.remove('is-visible');
banner.setAttribute('aria-hidden', 'true');
  }
/* Debug logging — silenced in production. Flip on by running
   `window.dhbDebug = true` in the console. console.error stays
   ungated because real errors should always surface. */
function dlog() {
if (!window.dhbDebug) return;
console.log.apply(console, arguments);
  }
function dwarn() {
if (!window.dhbDebug) return;
console.warn.apply(console, arguments);
  }
/* ── Bind all ── */
function bindAll() {
/* Designer-style error isolation: each binding wrapped in safe() so
   one failure can't kill the whole chain. Every function is logged
   if it throws. */
function safe(name, fn) {
try { fn(); }
catch (err) { console.error('[dhb] ' + name + ' failed:', err); }
    }
safe('btn-next', function () { tap(document.getElementById('dhb-btn-next'), goNext); });
safe('btn-back', function () { tap(document.getElementById('dhb-btn-back'), goBack); });
safe('btn-atc',  function () { tap(document.getElementById('dhb-btn-atc'),  function () { hideCartError(); submitCart(); }); });
safe('cart-error-close', function () { tap(document.getElementById('dhb-cart-error-close'), hideCartError); });
safe('bindSize',          bindSize);
safe('bindFlavor',        bindFlavor);
safe('bindDiet',          bindDiet);
safe('bindColors',        bindColors);
safe('bindRibbon',        bindRibbon);
safe('bindCherries',      bindCherries);
safe('bindTextStyle',     bindTextStyle);
safe('bindLetterColor',   bindLetterColor);
safe('bindMessageInputs', bindMessageInputs);
safe('bindPipingColor',   bindPipingColor);
safe('bindDecoColor',     bindDecoColor);
safe('bindSprinkleCards', bindSprinkleCards);
safe('bindCuteSprinkleStyle', bindCuteSprinkleStyle);
safe('bindPearlChoice',   bindPearlChoice);
safe('bindBurnAway',      bindBurnAway);
safe('bindPhoto',         bindPhoto);
safe('bindSummaryEdits',  bindSummaryEdits);
safe('bindAddons',        bindAddons);
safe('bindExtras',        bindExtras);
safe('initSwatchSwipeHints', initSwatchSwipeHints);
  }

  /* ── Mobile swipe-affordance for color swatch rows ──
     On mobile, the CSS turns flat-color swatch grids into a single
     horizontally-scrollable row to save vertical space. To make the
     scrollability discoverable, this function:
       1. Finds every grid that's actually overflowing horizontally
       2. Inserts a small "Swipe for more colors →" hint above it
       3. Listens for the first scroll, then fades both the hint
          (.is-hidden) and adds .is-scrolled to the grid
     Skipped on desktop. Skipped on grids with photo-backed ribbon
     swatches (those keep wrap layout). */
  function initSwatchSwipeHints() {
    if (window.innerWidth > 749) return;

    document.querySelectorAll('.dhb-swatch-grid').forEach(function (grid) {
      /* Avoid duplicates */
      if (grid.previousElementSibling && grid.previousElementSibling.classList.contains('dhb-swipe-hint')) return;

      var hint = document.createElement('div');
      hint.className = 'dhb-swipe-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.textContent = 'Swipe for more →';
      grid.parentNode.insertBefore(hint, grid);

      grid.addEventListener('scroll', function () {
        hint.classList.add('is-hidden');
      }, { passive: true, once: true });
    });
  }
/* ── Size ── */
function bindSize() {
document.querySelectorAll('.dhb-size-card').forEach(function(card) {
tap(card, function() {
document.querySelectorAll('.dhb-size-card').forEach(function(c) { c.classList.remove('is-selected'); });
card.classList.add('is-selected');
state.variantId = card.dataset.variantId;
state.basePrice = parseFloat(card.dataset.variantPrice) / 100;
state.sizeName  = card.dataset.variantTitle;
state.sizeKey   = card.dataset.variantKey;
syncVariantInput();
updateMessageLimits();
updatePrice();
setTimeout(goNext, 220);
      });
    });
  }
/* ── Flavor — ported from designer builder pattern ────────────────
   Uses plain `click` events (not custom tap helper) because pills and
   search input don't need touch-vs-scroll detection — they're simple
   buttons. The custom tap helper's preventDefault was suppressing
   native click behavior here on iOS. Pill selector is scoped to
   #dhb-step-flavor so it doesn't accidentally grab other steps' pills.
   ────────────────────────────────────────────────────────────────── */
function bindFlavor() {
/* Flavor cards — pick a flavor */
document.querySelectorAll('.dhb-flavor-item').forEach(function (item) {
item.addEventListener('click', function (e) {
e.preventDefault(); e.stopPropagation();
document.querySelectorAll('.dhb-flavor-item').forEach(function (i) {
i.classList.remove('is-selected');
i.setAttribute('aria-selected', 'false');
        });
this.classList.add('is-selected');
this.setAttribute('aria-selected', 'true');
state.flavor             = this.dataset.flavor;
state.flavorExtra        = parseInt(this.dataset.flavorPrice, 10) / 100 || 0;
state.flavorVariantTitle = this.dataset.flavorVariant || '';
/* EDIT 5: state.noGF / state.hasNuts kept as defensive backstops
   only — diet now comes before flavor, so filtering prevents
   incompatible flavors from ever being selectable. The previous
   "if state.noGF then state.diet.gf = false" lines are removed
   because that case can no longer occur. */
state.noGF    = NO_GF_FLAVORS.indexOf(state.flavor) > -1;
state.hasNuts = NUT_FLAVORS.indexOf(state.flavor) > -1;
updatePrice();
setTimeout(goNext, 220);
      });
item.addEventListener('keydown', function (e) {
if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
/* Search input */
var search = document.getElementById('dhb-flavor-search');
if (search) {
search.addEventListener('input', function () {
filterFlavors();
      });
    }
/* Filter pills — scoped to flavor step so we don't grab other pills */
document.querySelectorAll('#dhb-step-flavor .dhb-pill').forEach(function (pill) {
pill.addEventListener('click', function (e) {
e.preventDefault(); e.stopPropagation();
document.querySelectorAll('#dhb-step-flavor .dhb-pill').forEach(function (p) {
p.classList.remove('is-active');
        });
this.classList.add('is-active');
filterFlavors();
      });
    });
  }
/* EDIT 3: filterFlavors now also hides flavors that conflict with the
   customer's dietary selection. GF selected → hide data-nogf flavors.
   Nut allergy selected → hide data-nuts flavors. Search and category
   pill filters still apply on top. */
function filterFlavors() {
var q = '';
var s = document.getElementById('dhb-flavor-search');
if (s) q = s.value.toLowerCase();
var ap = document.querySelector('#dhb-step-flavor .dhb-pill.is-active');
var filter = ap ? ap.dataset.filter : 'all';
document.querySelectorAll('.dhb-flavor-item').forEach(function (item) {
var nm = !q || item.dataset.flavor.toLowerCase().indexOf(q) > -1;
var tm = !filter || filter === 'all' || item.dataset.category === filter;
/* Hide flavors incompatible with the customer's dietary selection.
   data-nogf="true" → hide when GF is selected
   data-nuts="true" → hide when Nut Allergy is selected */
var dietOk = true;
if (state.diet.gf  && item.dataset.nogf === 'true') dietOk = false;
if (state.diet.nut && item.dataset.nuts === 'true') dietOk = false;
item.style.display = (nm && tm && dietOk) ? '' : 'none';
    });
  }
/* ── Diet ── */
function bindDiet() {
tap(document.getElementById('dhb-diet-skip'), function() {
document.querySelectorAll('.dhb-diet-card').forEach(function(c) { c.classList.remove('is-selected'); });
state.diet.gf = false; state.diet.nut = false;
state.dietExtra = 0; state.nutAcked = false; state.gfAcked = false;
hideNutWarn(); hideGfWarn(); updatePrice();
if (state.currentStep < state.totalSteps) showStep(state.currentStep + 1);
    });
document.querySelectorAll('.dhb-diet-card').forEach(function(card) {
/* Skip vegan card — it has its own handler */
if (card.id === 'dhb-vegan-card') return;
tap(card, function() {
if (card.classList.contains('is-unavailable')) return;
var diet = card.dataset.diet;
if (!diet) return;
var sel  = card.classList.contains('is-selected');
card.classList.toggle('is-selected', !sel);
if (diet === 'gf') {
state.diet.gf = !sel;
state.gfAcked = false;
if (!sel) showGfWarn(); else hideGfWarn();
        }
if (diet === 'nut') {
state.diet.nut = !sel; state.nutAcked = false;
if (!sel) showNutWarn(); else hideNutWarn();
        }
state.dietExtra = state.diet.gf ? glutenFreePrice() : 0;
updatePrice();
      });
    });
/* ── Nut ack — use mousedown+touchstart to beat Dawn's handlers (matches signature builder) ── */
var ackEl = document.getElementById('dhb-nut-ack');
if (ackEl) {
function handleNutAck(e) {
e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
state.nutAcked = !state.nutAcked;
var box = document.getElementById('dhb-nut-box');
if (box) box.classList.toggle('is-checked', state.nutAcked);
ackEl.setAttribute('aria-checked', String(state.nutAcked));
      }
ackEl.addEventListener('mousedown',  handleNutAck);
ackEl.addEventListener('touchstart', handleNutAck, { passive: false });
ackEl.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleNutAck(e); } });
    }
/* ── GF ack — same pattern as nut ack ── */
var gfAckEl = document.getElementById('dhb-gf-ack');
if (gfAckEl) {
function handleGfAck(e) {
e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
state.gfAcked = !state.gfAcked;
var box = document.getElementById('dhb-gf-box');
if (box) box.classList.toggle('is-checked', state.gfAcked);
gfAckEl.setAttribute('aria-checked', String(state.gfAcked));
      }
gfAckEl.addEventListener('mousedown',  handleGfAck);
gfAckEl.addEventListener('touchstart', handleGfAck, { passive: false });
gfAckEl.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleGfAck(e); } });
    }
/* ── Vegan card — toggles the "not available" explanation panel ── */
var veganCard  = document.getElementById('dhb-vegan-card');
var veganPanel = document.getElementById('dhb-vegan-panel');
if (veganCard && veganPanel) {
function handleVegan(e) {
e.preventDefault(); e.stopPropagation();
var isOpen = veganCard.classList.contains('is-expanded');
veganCard.classList.toggle('is-expanded', !isOpen);
veganPanel.classList.toggle('is-visible', !isOpen);
veganPanel.setAttribute('aria-hidden', String(isOpen));
veganCard.setAttribute('aria-expanded', String(!isOpen));
      }
veganCard.addEventListener('mousedown',  handleVegan);
veganCard.addEventListener('touchstart', handleVegan, { passive: false });
veganCard.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleVegan(e); } });
    }
  }
/* EDIT 2: refreshDietStep simplified — diet now comes BEFORE flavor,
   so we don't know the flavor yet at this point. Both options always
   start as available; selection state is preserved if the customer
   comes back here from a later step. */
function refreshDietStep() {
var gfCard   = document.getElementById('dhb-gf-card');
var nutCard  = document.getElementById('dhb-nut-card');
var gfPrice  = document.getElementById('dhb-gf-price');
var nutPrice = document.getElementById('dhb-nut-price');
if (gfCard) {
gfCard.className = 'dhb-diet-card' + (state.diet.gf ? ' is-selected' : '');
if (gfPrice) gfPrice.textContent = '+$' + glutenFreePrice().toFixed(2);
    }
if (nutCard) {
nutCard.className = 'dhb-diet-card' + (state.diet.nut ? ' is-selected' : '');
if (nutPrice) nutPrice.textContent = 'No charge';
    }
  }
function showNutWarn() { var w = document.getElementById('dhb-nut-warning'); if (w) w.classList.add('is-visible'); }
function hideNutWarn() {
var w = document.getElementById('dhb-nut-warning'); if (w) w.classList.remove('is-visible');
var b = document.getElementById('dhb-nut-box'); if (b) b.classList.remove('is-checked');
  }
function showGfWarn() {
var w = document.getElementById('dhb-gf-warning'); if (w) w.classList.add('is-visible');
var r = document.getElementById('dhb-gf-review');  if (r) r.classList.add('is-visible');
  }
function hideGfWarn() {
var w = document.getElementById('dhb-gf-warning'); if (w) w.classList.remove('is-visible');
var r = document.getElementById('dhb-gf-review');  if (r) r.classList.remove('is-visible');
var b = document.getElementById('dhb-gf-box'); if (b) b.classList.remove('is-checked');
  }
/* ── Colors ── */
/* Color slot accordion (kicks in when color_count >= 3 — controlled by
   the .dhb-color-slot wrapper presence in the markup). Opens one slot at
   a time. After a color is picked, auto-collapses and auto-opens the
   next slot that doesn't yet have a non-default selection. */
function openSlot(slot) {
document.querySelectorAll('.dhb-color-slot').forEach(function(el) {
var s = el.dataset.slot;
var isThis = String(s) === String(slot);
el.classList.toggle('is-open', isThis);
var btn = el.querySelector('.dhb-color-slot-header');
if (btn) btn.setAttribute('aria-expanded', isThis ? 'true' : 'false');
    });
  }
function closeAllSlots() {
document.querySelectorAll('.dhb-color-slot').forEach(function(el) {
el.classList.remove('is-open');
var btn = el.querySelector('.dhb-color-slot-header');
if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }
function updateSlotHeader(slot, colorName, bg) {
var sw = document.getElementById('dhb-slot-header-swatch-' + slot);
if (sw) {
sw.style.background = bg || '';
sw.classList.add('is-filled');
    }
/* Title shows the picked color name; subtitle keeps the "Replaces ..."
   description so the customer always knows what each slot does. */
var title = document.getElementById('dhb-slot-header-title-' + slot);
if (title) {
title.textContent = colorName ? 'Color ' + slot + ' — ' + colorName : 'Color ' + slot;
    }
  }
/* On page load, populate accordion headers from any pre-selected
   swatches in the markup. Currently slot 1 ships with .is-selected on
   the "Like image" swatch — without this, the header circle would show
   an empty dashed "+" until the customer manually taps a color. */
function initSlotHeaders() {
document.querySelectorAll('.dhb-color-slot').forEach(function(slotEl) {
var slot = slotEl.dataset.slot;
var sel = slotEl.querySelector('.dhb-swatch.is-selected');
if (!sel) return;
var bg = sel.dataset.bg || '';
var color = sel.dataset.color || '';
/* For "Like image" slot 1, render the header swatch as the product
   image (matching the in-grid swatch). For other defaults, fall
   through to the standard color-fill behavior. */
var headerSw = document.getElementById('dhb-slot-header-swatch-' + slot);
if (headerSw && color === 'Like Image') {
var img = sel.querySelector('img');
if (img) {
headerSw.style.cssText = 'background-image: url(' + img.src + '); background-size: cover; background-position: center; background-color: #fff;';
headerSw.classList.add('is-filled');
        }
      }
/* Don't overwrite the title on init for Like Image — leave the
   default "Color N" header text as-is so it doesn't say "Color 1
   — Like Image" before the customer's even interacted. */
    });
  }
function advanceAccordion(currentSlot) {
/* Only operates if accordion mode is active (slots present in DOM). */
var slots = document.querySelectorAll('.dhb-color-slot');
if (!slots.length) return;
/* Find the first slot AFTER the current one with no selection. If
   none, close everything (customer's done). */
var current = parseInt(currentSlot, 10);
var nextEmpty = null;
slots.forEach(function(el) {
var i = parseInt(el.dataset.slot, 10);
if (i <= current) return;
if (nextEmpty !== null) return;
if (!state.colors[i] || state.colors[i] === 'Like Image') nextEmpty = i;
    });
if (nextEmpty !== null) openSlot(nextEmpty);
else closeAllSlots();
  }
function bindColorSlotHeaders() {
document.querySelectorAll('[data-slot-toggle]').forEach(function(btn) {
btn.addEventListener('click', function() {
var slot = btn.dataset.slotToggle;
var wrap = btn.closest('.dhb-color-slot');
if (!wrap) return;
if (wrap.classList.contains('is-open')) closeAllSlots();
else openSlot(slot);
      });
    });
  }
function bindColors() {
bindColorSlotHeaders();
document.querySelectorAll('.dhb-swatch[data-color-slot]').forEach(function(sw) {
tap(sw, function() {
var slot = sw.dataset.colorSlot;
var isCustom = sw.dataset.custom === 'true';
document.querySelectorAll('.dhb-swatch[data-color-slot="' + slot + '"]').forEach(function(s) { s.classList.remove('is-selected'); });
sw.classList.add('is-selected');
state.colors[slot] = sw.dataset.color;
state.customColorPrices[slot] = isCustom ? (optPrice('Custom color') || 10) : 0;
var picker = document.getElementById('dhb-color-picker-' + slot);
if (picker) picker.className = isCustom ? 'dhb-color-picker-wrap is-visible' : 'dhb-color-picker-wrap';
if (cfg.isMonochrome) {
var note = document.getElementById('dhb-monochrome-note');
if (note) {
note.classList.add('is-visible');
var c = sw.dataset.color;
note.textContent = (c === 'Black' || c === 'Buttercream White')
? 'Your cake will be in a single ' + c.toLowerCase() + ' tone throughout.'
: 'Your cake will be made in light and dark shades of ' + c + '. The mermaid tail, seashells and starfish will all match.';
          }
        }
/* Update preview bar */
var bg = sw.dataset.bg || '';
updateColorPreviewBar(slot, sw.dataset.color, bg);
/* Accordion: update header swatch. Auto-collapse + auto-advance ONLY
   for non-custom picks. For Custom, the slot stays open so the
   customer can finish picking their hex; advanceAccordion fires
   from the color picker's 'input' handler instead. */
updateSlotHeader(slot, sw.dataset.color, bg);
if (!isCustom) advanceAccordion(slot);
/* If the customer used the "Use as shown" shortcut and then picked
   an individual color, clear the shortcut's active state so the UI
   doesn't lie about what they actually selected. */
var uas = document.getElementById('dhb-use-as-shown');
if (uas) uas.classList.remove('is-active');
updatePrice();
/* No auto-advance on color — user must click Next */
      });
    });
document.querySelectorAll('.dhb-color-picker-input[data-color-slot]').forEach(function(inp) {
inp.addEventListener('input', function() {
var slot = inp.dataset.colorSlot;
state.colors[slot] = 'Custom ' + inp.value;
var prev = document.getElementById('dhb-color-preview-' + slot);
var hex  = document.getElementById('dhb-color-hex-' + slot);
if (prev) prev.style.background = inp.value;
if (hex)  hex.textContent = inp.value;
updateColorPreviewBar(slot, 'Custom', inp.value);
updatePrice();
      });
/* 'change' fires when the native color picker dialog closes (final
   commit of the selection). That's when we update the slot header
   with the picked hex and advance the accordion to the next slot. */
inp.addEventListener('change', function() {
var slot = inp.dataset.colorSlot;
updateSlotHeader(slot, 'Custom ' + inp.value, inp.value);
advanceAccordion(slot);
      });
    });
/* Use-as-shown shortcut: fills every color slot with "Like image" in
   one tap. Saves customers from expanding each slot and tapping the
   same option N times when they want the cake exactly like the photo.
   Only present in the DOM on accordion-mode cakes (3+ slots). */
var useAsShownBtn = document.getElementById('dhb-use-as-shown');
if (useAsShownBtn) {
tap(useAsShownBtn, function() {
var count = parseInt(useAsShownBtn.dataset.colorCount, 10) || 0;
for (var i = 1; i <= count; i++) {
var slotSwatches = document.querySelectorAll('.dhb-swatch[data-color-slot="' + i + '"]');
slotSwatches.forEach(function(s) { s.classList.remove('is-selected'); });
var likeImg = document.querySelector('.dhb-swatch[data-color-slot="' + i + '"][data-color="Like Image"]');
if (likeImg) {
likeImg.classList.add('is-selected');
state.colors[i] = 'Like Image';
state.customColorPrices[i] = 0;
/* Hide custom color picker if it was open for this slot. */
var picker = document.getElementById('dhb-color-picker-' + i);
if (picker) picker.className = 'dhb-color-picker-wrap';
/* Update preview bar + slot header (header swatch becomes the
   product photo, matching the in-grid Like image swatch). */
var bg = likeImg.dataset.bg || '';
updateColorPreviewBar(i, 'Like Image', bg);
var img = likeImg.querySelector('img');
var headerSw = document.getElementById('dhb-slot-header-swatch-' + i);
if (headerSw && img) {
headerSw.style.cssText = 'background-image: url(' + img.src + '); background-size: cover; background-position: center; background-color: #fff;';
headerSw.classList.add('is-filled');
            }
/* Title stays as plain "Color N" — saying "Color N — Like Image"
   reads weirdly in the collapsed header. */
          }
        }
/* Close every accordion slot and mark the shortcut button active. */
closeAllSlots();
useAsShownBtn.classList.add('is-active');
updatePrice();
/* Auto-advance to the next step — the customer has explicitly
   said "I want everything as shown" so there's nothing left
   to do on the color step. ~250ms delay lets the active state
   visually register before the page transitions. */
setTimeout(goNext, 250);
      });
    }
document.querySelectorAll('.dhb-preset-card').forEach(function(card) {
tap(card, function() {
document.querySelectorAll('.dhb-preset-card').forEach(function(c) { c.classList.remove('is-selected'); });
card.classList.add('is-selected');
state.presetColor = card.dataset.preset;
if (card.dataset.variantId) {
state.variantId = card.dataset.variantId;
state.basePrice = parseFloat(card.dataset.variantPrice) / 100;
syncVariantInput();
        }
updatePrice();
      });
    });
  }
/* ── Ribbon ── */
function bindRibbon() {
document.querySelectorAll('.dhb-swatch[data-ribbon], .dhb-ribbon-card').forEach(function(card) {
tap(card, function() {
document.querySelectorAll('#dhb-step-ribbon .dhb-swatch, #dhb-step-ribbon .dhb-ribbon-card').forEach(function(c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked','false'); });
card.classList.add('is-selected');
card.setAttribute('aria-checked','true');
state.ribbonColor = card.dataset.ribbon;
updatePrice();
      });
    });
/* Addon bow ribbon swatches */
document.querySelectorAll('.dhb-addon-bow-ribbon-card').forEach(function(card) {
tap(card, function() {
document.querySelectorAll('.dhb-addon-bow-ribbon-card').forEach(function(c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked','false'); });
card.classList.add('is-selected');
card.setAttribute('aria-checked','true');
state.extras.addBow.color = card.dataset.ribbon;
populateSummary();
      });
    });
  }
/* ── Cherries ──
   Scoped to #dhb-step-cherries so the add-on cherry cards (which also
   carry the .dhb-cherry-card class to inherit visual styling) don't
   get double-bound and silently set state.cherry / state.cherryPrice.
   That double-bind was causing a +$10 builder/cart price mismatch on
   cakes where cfg.hasCherries is false but addCherries is selected. */
function bindCherries() {
document.querySelectorAll('#dhb-step-cherries .dhb-cherry-card').forEach(function(card) {
tap(card, function() {
document.querySelectorAll('#dhb-step-cherries .dhb-cherry-card').forEach(function(c) { c.classList.remove('is-selected'); });
card.classList.add('is-selected');
state.cherry      = card.dataset.cherry;
state.cherryPrice = CHERRY_PRICES[state.cherry] || 0;
updatePrice();
      });
    });
  }
/* ── Text style ── */
function bindTextStyle() {
document.querySelectorAll('.dhb-text-card').forEach(function(card) {
tap(card, function() {
document.querySelectorAll('.dhb-text-card').forEach(function(c) { c.classList.remove('is-selected'); });
card.classList.add('is-selected');
state.textStyle = card.dataset.style;
updateMessageFields();
updatePrice();
      });
    });
  }
function updateMessageFields() {
var ff = document.getElementById('dhb-fondant-fields');
var bf = document.getElementById('dhb-bc-fields');
var lw = document.getElementById('dhb-letter-color-wrap');
var mf = document.getElementById('dhb-msg-fields');
if (!mf) return;
if (state.textStyle === 'none') { mf.className = 'dhb-msg-fields dhb-hidden'; return; }
mf.className = 'dhb-msg-fields';
if (lw) lw.className = cfg.hasLetterColors ? 'dhb-letter-color-wrap' : 'dhb-letter-color-wrap dhb-hidden';
if (state.textStyle === 'fondant') {
if (ff) ff.className = ''; if (bf) bf.className = 'dhb-hidden';
    } else {
if (ff) ff.className = 'dhb-hidden';
if (bf) {
bf.className = '';
var inp = document.getElementById('dhb-bc-input');
if (inp) { inp.style.fontFamily = TEXT_FONTS[state.textStyle]; inp.style.fontSize = state.textStyle === 'cursive' ? '26px' : '22px'; }
      }
    }
updateMessageLimits();
/* Re-apply letter color so the input font + color stay in sync after
   a text-style change (e.g. customer switches from cursive to fondant) */
var sel = document.querySelector('.dhb-letter-swatch.is-selected');
if (sel) applyLetterColorToInputs(sel.dataset.letterHex || '', sel.dataset.letter);
  }
function updateMessageLimits() {
if (!state.textStyle || state.textStyle === 'none') return;
var sk = cfg.isMini ? 'mini' : (state.sizeKey === 'large_heart' ? 'large' : 'medium');
var sizeLabel = cfg.isMini ? 'Mini' : (sk === 'large' ? 'Large' : 'Medium');
if (state.textStyle === 'fondant') {
var lim = CHAR_LIMITS.fondant[sk];
var l1 = document.getElementById('dhb-fondant-line1'); if (l1) l1.maxLength = lim.l1;
var l2 = document.getElementById('dhb-fondant-line2'); if (l2) l2.maxLength = lim.l2;
var m1 = document.getElementById('dhb-fl1max'); if (m1) m1.textContent = lim.l1;
var m2 = document.getElementById('dhb-fl2max'); if (m2) m2.textContent = lim.l2;
var n  = document.getElementById('dhb-fondant-note'); if (n) n.textContent = sizeLabel + ': max ' + lim.l1 + ' chars line 1, ' + lim.l2 + ' chars line 2';
    } else {
var max = CHAR_LIMITS[state.textStyle][sk];
var bi  = document.getElementById('dhb-bc-input'); if (bi) bi.maxLength = max;
var bm  = document.getElementById('dhb-bcmax'); if (bm) bm.textContent = max;
var bn  = document.getElementById('dhb-bc-note'); if (bn) bn.textContent = sizeLabel + ': max ' + max + ' characters';
    }
  }
/* ── Letter color ── */
function bindLetterColor() {
document.querySelectorAll('.dhb-letter-swatch').forEach(function(sw) {
tap(sw, function() {
document.querySelectorAll('.dhb-letter-swatch').forEach(function(s) { s.classList.remove('is-selected'); s.setAttribute('aria-checked', 'false'); });
sw.classList.add('is-selected');
sw.setAttribute('aria-checked', 'true');
state.letterColor       = sw.dataset.letter;
state.customLetterPrice = sw.dataset.letter === 'Custom' ? (optPrice('Custom letter color') || 5) : 0;
var pw = document.getElementById('dhb-letter-color-picker-wrap');
if (pw) pw.className = state.letterColor === 'Custom' ? 'dhb-color-picker-wrap is-visible' : 'dhb-color-picker-wrap';
/* Live: paint every message input in the chosen color so the input
   IS the preview. Reads the hex from the swatch's data-letter-hex
   (set in Liquid for cake-palette colors). Falls back gracefully
   for Like Image (faint purple-grey, italic) and Custom. */
var hex = sw.dataset.letterHex || '';
applyLetterColorToInputs(hex, sw.dataset.letter);
updatePrice();
      });
    });
var lp = document.getElementById('dhb-letter-color-picker');
if (lp) lp.addEventListener('input', function() {
state.letterColor = 'Custom ' + lp.value;
var prev = document.getElementById('dhb-letter-color-preview'); if (prev) prev.style.background = lp.value;
var hex  = document.getElementById('dhb-letter-color-hex');     if (hex)  hex.textContent = lp.value;
applyLetterColorToInputs(lp.value, 'Custom');
updatePrice();
    });
  }
/* Apply the chosen letter color (hex) and current text style font to
   every message input (fondant line 1/2, buttercream message, burn-away
   line 1/2). Called on letter color pick + on text style change.
   This makes the input itself the live preview — no separate preview
   block needed. */
function applyLetterColorToInputs(hex, label) {
var inputs = document.querySelectorAll('.dhb-msg-input');
if (!inputs.length) return;
var color = hex || '';
/* Like Image — keep a neutral grey since "match the photo" has no
   single hex. Italic to suggest "we'll figure it out from your image." */
var isLikeImage = (label === 'Like Image');
var fontFamily = TEXT_FONTS[state.textStyle] || '';
inputs.forEach(function (inp) {
if (color && !isLikeImage) {
inp.style.color = color;
      } else {
inp.style.color = '';
      }
inp.style.fontStyle = isLikeImage ? 'italic' : '';
if (fontFamily) inp.style.fontFamily = fontFamily;
    });
  }
/* ── Message inputs ── */
function bindMessageInputs() {
var l1 = document.getElementById('dhb-fondant-line1');
var l2 = document.getElementById('dhb-fondant-line2');
var bc = document.getElementById('dhb-bc-input');
if (l1) l1.addEventListener('input', function() { state.msgLine1 = this.value; var c = document.getElementById('dhb-fl1c'); if (c) c.textContent = this.value.length; });
if (l2) l2.addEventListener('input', function() { state.msgLine2 = this.value; var c = document.getElementById('dhb-fl2c'); if (c) c.textContent = this.value.length; });
if (bc) bc.addEventListener('input',  function() { state.msgText  = this.value; var c = document.getElementById('dhb-bcc');  if (c) c.textContent = this.value.length; });
  }
/* ── Piping color ── */
function bindPipingColor() {
var toggle = document.getElementById('dhb-piping-toggle');
if (!toggle) return;
tap(toggle, function() {
var panel  = document.getElementById('dhb-piping-panel');
var isOpen = toggle.classList.contains('is-selected');
toggle.classList.toggle('is-selected', !isOpen);
if (panel) panel.className = isOpen ? 'dhb-hidden' : '';
state.pipingExtra = isOpen ? 0 : (optPrice('Custom piping color') || 5);
if (isOpen) state.pipingColor = '';
updatePrice();
populateSummary();
    });
document.querySelectorAll('.dhb-piping-swatch').forEach(function(sw) {
tap(sw, function() {
document.querySelectorAll('.dhb-piping-swatch').forEach(function(s) { s.classList.remove('is-selected'); s.setAttribute('aria-checked', 'false'); });
sw.classList.add('is-selected');
sw.setAttribute('aria-checked', 'true');
state.pipingColor = sw.dataset.color;
updatePrice();
populateSummary();
      });
    });
  }
/* ── Decoration color ── */
function bindDecoColor() {
document.querySelectorAll('.dhb-deco-card').forEach(function(card) {
tap(card, function() {
document.querySelectorAll('.dhb-deco-card').forEach(function(c) { c.classList.remove('is-selected'); });
card.classList.add('is-selected');
state.decoColor = card.dataset.deco;
updatePrice();
      });
    });
  }
/* ── Sprinkle cards (dedicated step) ──
   Mirrors the designer-cake-builder sprinkle picker pattern: photo
   thumbnails, friendly names, optional price (most are free, pearls
   add $10). State stores { key, name, price } so cart submission
   can look up the matching Shopify variant. No pre-selected default
   on this picker — the customer must actively pick one. */
function bindSprinkleCards() {
var cards = document.querySelectorAll('.dhb-sprinkle-card');
if (!cards.length) return;
cards.forEach(function(card) {
tap(card, function() {
cards.forEach(function(c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
card.classList.add('is-selected');
card.setAttribute('aria-checked', 'true');
state.sprinkle.key   = card.dataset.sprinkleKey;
state.sprinkle.name  = card.dataset.sprinkleName;
state.sprinkle.price = parseInt(card.dataset.sprinklePrice, 10) / 100;
updatePrice();
      });
    });
  }
/* ── Cute Sprinkle style step ──
   Writes to state.sprinkle (same slot as the regular sprinkles step)
   so cart push, property labels, and price logic all "just work"
   without duplicate state. Both options are free, so price is 0. */
function bindCuteSprinkleStyle() {
var cards = document.querySelectorAll('.dhb-css-card');
if (!cards.length) return;
cards.forEach(function(card) {
tap(card, function() {
cards.forEach(function(c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
card.classList.add('is-selected');
card.setAttribute('aria-checked', 'true');
state.sprinkle.key   = card.dataset.cssKey;
state.sprinkle.name  = card.dataset.cssName;
state.sprinkle.price = 0;
updatePrice();
      });
    });
  }
/* ── Pearl choice ── */
function bindPearlChoice() {
var pearlCards = document.querySelectorAll('.dhb-pearl-card');
if (!pearlCards.length) return;
/* Sync state to match the visually-selected default (first card) */
var firstSelected = document.querySelector('.dhb-pearl-card.is-selected');
if (firstSelected) state.pearlChoice = firstSelected.dataset.pearl;
pearlCards.forEach(function(card) {
tap(card, function() {
pearlCards.forEach(function(c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
card.classList.add('is-selected');
card.setAttribute('aria-checked', 'true');
state.pearlChoice = card.dataset.pearl;
      });
    });
  }
/* ── Burn away ── */
function bindBurnAway() {
document.querySelectorAll('.dhb-burnaway-top-card').forEach(function(card) {
tap(card, function() {
document.querySelectorAll('.dhb-burnaway-top-card').forEach(function(c) { c.classList.remove('is-selected'); });
card.classList.add('is-selected');
state.burnAwayTop = card.dataset.top;
var cw = document.getElementById('dhb-calendar-wrap');
var iw = document.getElementById('dhb-burnaway-img-wrap');
if (cw) { if (state.burnAwayTop === 'calendar') cw.removeAttribute('hidden'); else cw.setAttribute('hidden', ''); }
if (iw) { if (state.burnAwayTop === 'image')    iw.removeAttribute('hidden'); else iw.setAttribute('hidden', ''); }
      });
    });
document.querySelectorAll('.dhb-reveal-card').forEach(function(card) {
tap(card, function() {
document.querySelectorAll('.dhb-reveal-card').forEach(function(c) { c.classList.remove('is-selected'); });
card.classList.add('is-selected');
state.revealType          = card.dataset.reveal;
state.revealImageUpcharge = state.revealType === 'image' ? (optPrice('Burn away reveal image') || 20) : 0;
var fr = document.getElementById('dhb-reveal-fondant');
var ir = document.getElementById('dhb-reveal-image');
if (fr) { if (state.revealType === 'fondant') fr.removeAttribute('hidden'); else fr.setAttribute('hidden', ''); }
if (ir) { if (state.revealType === 'image')   ir.removeAttribute('hidden'); else ir.setAttribute('hidden', ''); }
updatePrice();
      });
    });
/* Burn away reveal fondant inputs — use dhb-ba-* IDs (unique, no conflict with message step) */
var bal1 = document.getElementById('dhb-ba-line1');
var bal2 = document.getElementById('dhb-ba-line2');
if (bal1) bal1.addEventListener('input', function() {
state.msgLine1 = this.value;
var c = document.getElementById('dhb-ba-l1c'); if (c) c.textContent = this.value.length;
    });
if (bal2) bal2.addEventListener('input', function() {
state.msgLine2 = this.value;
var c = document.getElementById('dhb-ba-l2c'); if (c) c.textContent = this.value.length;
    });
var ms = document.getElementById('dhb-burn-month'); if (ms) ms.addEventListener('change', function() { state.burnMonth = this.value; });
var di = document.getElementById('dhb-burn-day');   if (di) di.addEventListener('input',  function() { state.burnDay   = this.value; });
bindHeartCropper({
targetId:        'top',
uploadInputId:   'dhb-burnaway-top-upload',
uploadWrapId:    'dhb-burnaway-top-upload-wrap',
cropperRootId:   'dhb-burnaway-top-cropper',
cropperImgId:    'dhb-burnaway-top-cropper-img',
nameDisplayId:   'dhb-burnaway-top-preview-name',
stateNameKey:    'burnAwayTopFileName',
stateCropperKey: 'burnAwayTopCropper',
stateUrlKey:     'burnAwayTopUrl',
zoomInId:        'dhb-burnaway-top-zoom-in',
zoomOutId:       'dhb-burnaway-top-zoom-out',
resetId:         'dhb-burnaway-top-reset',
replaceId:       'dhb-burnaway-top-replace'
    });
bindHeartCropper({
targetId:        'reveal',
uploadInputId:   'dhb-reveal-upload',
uploadWrapId:    'dhb-reveal-upload-wrap',
cropperRootId:   'dhb-reveal-cropper',
cropperImgId:    'dhb-reveal-cropper-img',
nameDisplayId:   'dhb-reveal-preview-name',
stateNameKey:    'revealImageName',
stateCropperKey: 'revealImageCropper',
stateUrlKey:     'revealImageUrl',
zoomInId:        'dhb-reveal-zoom-in',
zoomOutId:       'dhb-reveal-zoom-out',
resetId:         'dhb-reveal-reset',
replaceId:       'dhb-reveal-replace'
    });
  }
/* ──────────────────────────────────────────────────────────────
   Heart-shape image cropper — top-level sibling so bindBurnAway
   AND bindPhoto can both call it. Previously this was nested
   inside bindBurnAway, which scoped it locally and caused
   bindPhoto to throw ReferenceError on every page load.
   Creates a Cropper.js instance on a square crop box; the visible
   stage is heart-clipped via SVG so the customer sees only the
   heart-shaped region. Driven by the `targetId` parameter.
   ────────────────────────────────────────────────────────────── */
function bindHeartCropper(opts) {
/* opts:
   targetId      — 'top' or 'reveal' or 'photo' (for state field names)
   uploadInputId — file input element id
   uploadWrapId  — dropzone wrapper id (hidden when image active)
   cropperRootId — the entire heart-cropper container id
   cropperImgId  — the <img> element cropper takes over
   nameDisplayId — element that shows the filename
   stateNameKey  — state field to write filename to
   stateCropperKey — state field where the live cropper instance lives
   stateUrlKey   — state field where uploaded Cloudinary URL is stored
   zoomInId, zoomOutId, resetId, replaceId — control button ids */
var fi = document.getElementById(opts.uploadInputId);
if (!fi) return; /* this product variant doesn't have this upload */

var cropperTries = 0;
var uploadToken = 0;
function setUploadStatus(kind) {
var host = document.getElementById(opts.cropperRootId + '-ustat');
if (!host) {
var root = document.getElementById(opts.cropperRootId);
host = document.createElement('div');
host.id = opts.cropperRootId + '-ustat';
host.setAttribute('role', 'status');
host.setAttribute('aria-live', 'polite');
host.style.cssText = 'margin-top:8px;font-size:13px;font-weight:600;text-align:center;line-height:1.45;';
if (root && root.parentNode) root.parentNode.insertBefore(host, root.nextSibling);
else if (fi && fi.parentNode) fi.parentNode.appendChild(host);
      }
if (kind === 'uploading') { host.style.color = '#7a5791'; host.textContent = '\u23F3 Uploading your photo\u2026'; }
else if (kind === 'done') { host.style.color = '#0a6b2e'; host.textContent = '\u2705 Photo uploaded \u2014 you\u2019re all set.'; }
else if (kind === 'failed') { host.style.color = '#b91c1c'; host.textContent = '\u26A0\uFE0F Upload didn\u2019t go through \u2014 please check your connection and select your photo again.'; }
else { host.textContent = ''; }
    }
function uploadRawImage(file) {
var myToken = ++uploadToken;
setUploadStatus('uploading');
state[opts.stateUrlKey + 'RawPromise'] = new Promise(function (resolve) {
var attempt = 0;
(function attemptUpload() {
attempt++;
var form = new FormData();
form.append('file', file);
form.append('upload_preset', CLOUDINARY_PRESET);
fetch(CLOUDINARY_URL, { method: 'POST', body: form })
        .then(function (r) { if (!r.ok) throw new Error('Cloudinary HTTP ' + r.status); return r.json(); })
        .then(function (data) {
if (myToken !== uploadToken) return resolve(null);
if (!data || !data.secure_url) throw new Error('No URL returned');
if (!state[opts.stateUrlKey]) state[opts.stateUrlKey] = data.secure_url;
setUploadStatus('done');
resolve(data);
        })
        .catch(function (err) {
if (myToken !== uploadToken) return resolve(null);
if (attempt < 3) { setTimeout(attemptUpload, 1500); return; }
setUploadStatus('failed');
dwarn('[dhb] raw image upload failed (' + opts.stateNameKey + '):', err && err.message);
resolve(null);
        });
    })();
    });
return state[opts.stateUrlKey + 'RawPromise'];
    }

function showDropzone() {
var uw = document.getElementById(opts.uploadWrapId);
var cr = document.getElementById(opts.cropperRootId);
if (uw) uw.classList.remove('is-hidden');
if (cr) cr.setAttribute('hidden', '');
    }
function hideDropzone() {
var uw = document.getElementById(opts.uploadWrapId);
var cr = document.getElementById(opts.cropperRootId);
if (uw) uw.classList.add('is-hidden');
if (cr) cr.removeAttribute('hidden');
    }
function destroyCropper() {
if (state[opts.stateCropperKey]) {
try { state[opts.stateCropperKey].destroy(); } catch (e) {}
state[opts.stateCropperKey] = null;
      }
if (state[opts.stateNameKey + 'ObjectUrl']) {
try { URL.revokeObjectURL(state[opts.stateNameKey + 'ObjectUrl']); } catch (e) {}
state[opts.stateNameKey + 'ObjectUrl'] = null;
      }
    }
function clearAll() {
destroyCropper();
showDropzone();
state[opts.stateNameKey] = '';
state[opts.stateUrlKey]  = '';
var fnEl = document.getElementById(opts.uploadInputId.replace('-upload', '-file-name'));
if (fnEl) fnEl.textContent = '';
fi.value = '';
    }
function initCropper() {
var imgEl = document.getElementById(opts.cropperImgId);
if (!imgEl) return;
if (typeof window.Cropper === 'undefined') {
/* Cropper.js not loaded yet — retry, but give up after ~4s so we never
   spin forever. The raw photo is already uploading regardless. */
if (cropperTries++ < 20) { setTimeout(initCropper, 200); return; }
dwarn('[dhb] Cropper unavailable — proceeding with raw upload, no crop UI.');
return;
      }
try {
var c = new window.Cropper(imgEl, {
aspectRatio: 1,
viewMode: 1,
dragMode: 'move',
autoCropArea: 1,
guides: false,
center: false,
highlight: false,
cropBoxMovable: false,
cropBoxResizable: false,
toggleDragModeOnDblclick: false,
background: false,
modal: false,
movable: true,
zoomable: true,
zoomOnTouch: true,
zoomOnWheel: true,
wheelZoomRatio: 0.1,
minContainerWidth: 200,
minContainerHeight: 200,
crop: function (event) {
state[opts.stateNameKey + 'CropData'] = {
x:      Math.round(event.detail.x),
y:      Math.round(event.detail.y),
width:  Math.round(event.detail.width),
height: Math.round(event.detail.height)
            };
          }
        });
state[opts.stateCropperKey] = c;
      } catch (err) {
dwarn('[dhb] Heart cropper init failed:', err);
      }
    }
fi.addEventListener('change', function () {
var f = this.files && this.files[0]; if (!f) return;
/* File size guard — 10MB max. Cropper.js can technically handle
   larger files but mobile browsers struggle and Cloudinary uploads
   take forever. Better to reject upfront with a clear message. */
var MAX_BYTES = 10 * 1024 * 1024; /* 10 MB */
if (f.size > MAX_BYTES) {
showCartError('That photo is too big (' + Math.round(f.size / 1024 / 1024) + ' MB). Please use a photo under 10 MB.');
this.value = '';
return;
      }
/* Type guard — should never trigger with accept="image/*" but
   belt-and-suspenders for older mobile browsers. */
if (!f.type || f.type.indexOf('image/') !== 0) {
showCartError('Please choose an image file (JPEG, PNG, or HEIC).');
this.value = '';
return;
      }
destroyCropper();
var url = URL.createObjectURL(f);
state[opts.stateNameKey + 'ObjectUrl'] = url;
var imgEl = document.getElementById(opts.cropperImgId);
if (imgEl) imgEl.src = url;
state[opts.stateNameKey] = f.name;
state[opts.stateUrlKey]  = ''; /* reset Cloudinary URL — re-uploads on next add-to-cart */
var nm = document.getElementById(opts.nameDisplayId);
if (nm) nm.textContent = f.name;
var fnEl = document.getElementById(opts.uploadInputId.replace('-upload', '-file-name'));
if (fnEl) fnEl.textContent = f.name;
hideDropzone();
cropperTries = 0;
uploadRawImage(f);
/* Wait one frame so the cropper container is in the DOM */
requestAnimationFrame(initCropper);
    });
tap(document.getElementById(opts.zoomInId),  function () { var c = state[opts.stateCropperKey]; if (c) c.zoom(0.1);  });
tap(document.getElementById(opts.zoomOutId), function () { var c = state[opts.stateCropperKey]; if (c) c.zoom(-0.1); });
tap(document.getElementById(opts.resetId),   function () { var c = state[opts.stateCropperKey]; if (c) c.reset();    });
tap(document.getElementById(opts.replaceId), function () { clearAll(); fi.click(); });
  }
/* ── Photo upload ── */
function bindPhoto() {
bindHeartCropper({
targetId:        'photo',
uploadInputId:   'dhb-photo-upload',
uploadWrapId:    'dhb-photo-wrap',
cropperRootId:   'dhb-photo-cropper',
cropperImgId:    'dhb-photo-cropper-img',
nameDisplayId:   'dhb-photo-preview-name',
stateNameKey:    'photoFileName',
stateCropperKey: 'photoCropper',
stateUrlKey:     'photoUrl',
zoomInId:        'dhb-photo-zoom-in',
zoomOutId:       'dhb-photo-zoom-out',
resetId:         'dhb-photo-reset',
replaceId:       'dhb-photo-replace'
    });
  }
/* ── Summary edits ── */
function bindSummaryEdits() {
document.querySelectorAll('.dhb-sum-edit').forEach(function(btn) {
tap(btn, function() { var s = btn.dataset.step; if (s) goToStep(s); });
    });
  }
/* ── Addons ── */
function bindAddons() {
/* Skip button on the new "Make it pretty" step — just advances. */
tap(document.getElementById('dhb-decoratives-skip'), function () { goNext(); });
tap(document.getElementById('dhb-addon-row-candles'), function() { toggleAddon('candles'); });
tap(document.getElementById('dhb-addon-row-gift'),    function() { toggleAddon('gift'); });
document.querySelectorAll('.dhb-type-pill').forEach(function(pill) {
tap(pill, function() {
var type = pill.dataset.type;
var typeState = state.addons.candles.types[type];
if (!typeState) return;
/* Toggle this type's active state — does NOT affect other types */
typeState.active = !typeState.active;
pill.classList.toggle('is-selected', typeState.active);
pill.setAttribute('aria-checked', typeState.active ? 'true' : 'false');
/* Show/hide this type's sub-panel */
var sub = document.getElementById('dhb-candle-sub-' + type);
if (sub) sub.classList.toggle('is-visible', typeState.active);
/* Clear color/number when deactivating so cart doesn't keep stale data */
if (!typeState.active) {
if (type === 'metallic') typeState.color = '';
if (type === 'number')   { typeState.color = ''; typeState.number = ''; }
        }
updatePrice();
      });
    });
document.querySelectorAll('.dhb-img-tile[data-tile-group], .dhb-swatch[data-tile-group]').forEach(function(tile) {
tap(tile, function() {
var g = tile.dataset.tileGroup;
document.querySelectorAll('.dhb-img-tile[data-tile-group="' + g + '"], .dhb-swatch[data-tile-group="' + g + '"]').forEach(function(t) { t.classList.remove('is-selected'); t.setAttribute('aria-checked','false'); });
tile.classList.add('is-selected');
tile.setAttribute('aria-checked','true');
/* Route to the correct type's color slot. Splitting metallic-color
   vs number-color (was previously a single shared "candle-color"
   group) lets a customer pick Metallic Gold AND Number Pink at
   the same time without colors clobbering each other. */
if (g === 'metallic-color') state.addons.candles.types.metallic.color = tile.dataset.tileValue;
if (g === 'number-color')   state.addons.candles.types.number.color   = tile.dataset.tileValue;
      });
    });
var cn = document.getElementById('dhb-candle-number');
if (cn) cn.addEventListener('input', function() {
state.addons.candles.types.number.number = this.value;
updatePrice();
    });
var gt = document.getElementById('dhb-gift-text');     if (gt) gt.addEventListener('input', function() { state.addons.gift.text = this.value; });
/* ── Missed-candles nudge buttons ── */
tap(document.getElementById('dhb-candle-nudge-add'), function() {
/* Activate candles row + Metallic type + Gold color via new model */
if (!state.addons.candles.sel) toggleAddon('candles');
state.addons.candles.types.metallic.active = true;
state.addons.candles.types.metallic.color  = 'Gold';
var metallicPill = document.querySelector('.dhb-type-pill[data-type="metallic"]');
if (metallicPill) {
metallicPill.classList.add('is-selected');
metallicPill.setAttribute('aria-checked', 'true');
    }
var metallicSub = document.getElementById('dhb-candle-sub-metallic');
if (metallicSub) metallicSub.classList.add('is-visible');
/* Mark the Gold tile inside the metallic sub as selected */
document.querySelectorAll('#dhb-candle-sub-metallic .dhb-img-tile').forEach(function(t) {
t.classList.toggle('is-selected', t.dataset.tileValue === 'Gold');
t.setAttribute('aria-checked', t.dataset.tileValue === 'Gold' ? 'true' : 'false');
    });
var nudge = document.getElementById('dhb-candle-nudge');
if (nudge) nudge.setAttribute('hidden', '');
updatePrice();
populateSummary();
    });
tap(document.getElementById('dhb-candle-nudge-skip'), function() {
window.dhbNudgeDismissed = true;
var nudge = document.getElementById('dhb-candle-nudge');
if (nudge) nudge.setAttribute('hidden', '');
    });
  }
function toggleAddon(id) {
var card  = document.getElementById('dhb-addon-card-' + id);
var panel = document.getElementById('dhb-sub-panel-' + id);
var isOpen = card && card.classList.contains('is-selected');
if (card)  card.classList.toggle('is-selected', !isOpen);
if (panel) panel.classList.toggle('is-open', !isOpen);
state.addons[id].sel = !isOpen;
if (isOpen) {
if (id === 'candles') {
/* Reset all candle types when the parent candles row is closed */
var ts = state.addons.candles.types;
ts.rainbow.active = false;
ts.metallic.active = false; ts.metallic.color = '';
ts.number.active = false;   ts.number.color = ''; ts.number.number = '';
ts.sparklers.active = false;
document.querySelectorAll('.dhb-type-pill').forEach(function(p) {
p.classList.remove('is-selected');
p.setAttribute('aria-checked', 'false');
        });
document.querySelectorAll('.dhb-candle-sub').forEach(function(s) { s.classList.remove('is-visible'); });
document.querySelectorAll('.dhb-img-tile.is-selected[data-tile-group="metallic-color"], .dhb-img-tile.is-selected[data-tile-group="number-color"], .dhb-swatch.is-selected[data-tile-group="number-color"]').forEach(function(t) {
t.classList.remove('is-selected');
t.setAttribute('aria-checked', 'false');
        });
var nin = document.getElementById('dhb-candle-number'); if (nin) nin.value = '';
      }
if (id === 'gift') { state.addons.gift.text = ''; var ta = document.getElementById('dhb-gift-text'); if (ta) ta.value = ''; }
    }
updatePrice();
  }
/* ── Extras ── */
function bindExtras() {
    ['bow','server','coldpack'].forEach(function(id) {
tap(document.getElementById('dhb-extra-' + id), function() {
state.extras[id].sel = !state.extras[id].sel;
var el = document.getElementById('dhb-extra-' + id);
if (el) el.classList.toggle('is-selected', state.extras[id].sel);
updatePrice();
      });
    });
tap(document.getElementById('dhb-addon-cherries-row'), toggleAddonCherry);
document.querySelectorAll('.dhb-addon-cherry-card').forEach(function(card) {
tap(card, function() {
document.querySelectorAll('.dhb-addon-cherry-card').forEach(function(c) { c.classList.remove('is-selected'); });
card.classList.add('is-selected');
state.extras.addCherries.type  = card.dataset.cherry;
/* Pricing model: $10 base for ANY cherries on this addon step,
   plus the upcharge from CHERRY_PRICES (Gold/Silver/Rose Gold = +$10).
   So Fake/Maraschino = $10 total, metallic = $20 total. The gate
   in calcTotal uses `>= 20` to pick the Metallic Shopify variant. */
state.extras.addCherries.price = 10 + (CHERRY_PRICES[card.dataset.cherry] || 0);
updatePrice();
populateSummary();
      });
    });
tap(document.getElementById('dhb-addon-bow-row'), toggleAddonBow);
tap(document.getElementById('dhb-addon-glitter'), function() {
state.extras.addGlitter.sel = !state.extras.addGlitter.sel;
var el = document.getElementById('dhb-addon-glitter');
if (el) el.classList.toggle('is-selected', state.extras.addGlitter.sel);
updatePrice();
populateSummary();
    });
  }
function toggleAddonCherry() {
var card  = document.getElementById('dhb-addon-cherries-card');
var panel = document.getElementById('dhb-addon-cherries-panel');
var isOpen = card && card.classList.contains('is-selected');
if (card)  card.classList.toggle('is-selected', !isOpen);
if (panel) panel.classList.toggle('is-open', !isOpen);
state.extras.addCherries.sel = !isOpen;
if (isOpen) {
/* Toggling OFF — clear everything including the visual selection
   on cherry style cards so toggling back ON doesn't show stale state. */
state.extras.addCherries.type = '';
state.extras.addCherries.price = 0;
document.querySelectorAll('.dhb-addon-cherry-card').forEach(function(c) {
c.classList.remove('is-selected');
c.setAttribute('aria-checked', 'false');
      });
    } else {
/* Toggling ON — sync state to match the visually-selected first
   cherry style (Fake cherries). The Liquid pre-selects the first
   card with `is-selected`; we just mirror that into state so the
   customer doesn't need to tap it again. */
state.extras.addCherries.type  = 'Fake cherries';
state.extras.addCherries.price = 10;
var firstCard = document.querySelector('.dhb-addon-cherry-card[data-cherry="Fake cherries"]');
if (firstCard) {
firstCard.classList.add('is-selected');
firstCard.setAttribute('aria-checked', 'true');
      }
    }
updatePrice();
populateSummary();
  }
function toggleAddonBow() {
var card  = document.getElementById('dhb-addon-bow-card');
var panel = document.getElementById('dhb-addon-bow-panel');
var isOpen = card && card.classList.contains('is-selected');
if (card)  card.classList.toggle('is-selected', !isOpen);
if (panel) panel.classList.toggle('is-open', !isOpen);
state.extras.addBow.sel = !isOpen;
if (isOpen) {
/* Toggling OFF — clear the ribbon color and remove the visual
   selection from any ribbon swatch so the customer doesn't see
   stale state if they toggle bows back on. */
state.extras.addBow.color = '';
document.querySelectorAll('.dhb-addon-bow-ribbon-card').forEach(function(c) {
c.classList.remove('is-selected');
c.setAttribute('aria-checked', 'false');
      });
    }
updatePrice();
populateSummary();
  }
/* ── Color preview bar ── */
function updateColorPreviewBar(slot, colorName, bg) {
    ['dhb-cpb-swatch-' + slot, 'dhb-cpb-swatch-r' + slot].forEach(function(id) {
var swatch = document.getElementById(id);
if (swatch && bg) {
swatch.setAttribute('style', 'background:' + bg + ' !important;border-style:solid;border-color:rgba(0,0,0,0.1);');
swatch.classList.add('is-set');
      }
    });
    ['dhb-cpb-label-' + slot, 'dhb-cpb-label-r' + slot].forEach(function(id) {
var label = document.getElementById(id);
if (label) label.textContent = colorName === 'Like Image' ? 'Like image' : colorName;
    });
/* Hide preview bar if ANY selected color is "Like image" */
var anyLikeImage = false;
for (var i = 1; i <= (cfg.colorCount || 1); i++) {
if (!state.colors[i] || state.colors[i] === 'Like Image') { anyLikeImage = true; break; }
    }
    ['dhb-color-preview-bar', 'dhb-color-preview-bar-review'].forEach(function(id) {
var bar = document.getElementById(id);
if (bar) bar.style.display = anyLikeImage ? 'none' : '';
    });
  }
/* ── Summary ── */
function populateSummary() {
function set(id, val) { var el = document.getElementById(id); if (el) el.textContent = val || '—'; }
/* Helper — find the hex value for a chosen color name by reading from
   the existing color picker swatches in the DOM. Avoids duplicating the
   color palette as a JS map. Falls back to undefined if not found. */
function colorHex(colorName) {
if (!colorName) return null;
var sw = document.querySelector('.dhb-swatch[data-color="' + colorName + '"]');
if (sw && sw.dataset.bg) return sw.dataset.bg;
/* Custom color stores the hex directly in state.colors[i] as "Custom #ABCDEF" */
if (colorName.indexOf('Custom ') === 0) return colorName.replace('Custom ', '').trim();
return null;
    }
/* Helper — read ribbon image URL from existing ribbon swatch in the
   ribbon picker (it has the photo as background-image already). */
function ribbonImage(ribbonName) {
if (!ribbonName) return null;
var rs = document.querySelector('.dhb-swatch--ribbon[data-ribbon="' + ribbonName + '"] .dhb-swatch-circle');
if (rs) {
var bg = rs.style.backgroundImage;
return bg && bg !== 'none' ? bg : null;
      }
return null;
    }
/* Helper — set background-image with raw url() string */
function setThumbImg(id, urlOrCss) {
var el = document.getElementById(id);
if (!el) return;
if (urlOrCss) el.style.backgroundImage = urlOrCss.indexOf('url(') === 0 ? urlOrCss : 'url(' + urlOrCss + ')';
else el.style.backgroundImage = '';
    }
function setThumbColor(id, hex) {
var el = document.getElementById(id);
if (!el) return;
el.style.backgroundColor = hex || '';
    }
/* Helper — set font-family on a thumb element + value */
function setFontStyle(id, fontFamily, color) {
var el = document.getElementById(id);
if (!el) return;
if (fontFamily) el.style.fontFamily = fontFamily;
if (color) el.style.color = color;
    }
/* Map text style key → CSS font-family used in the upstream picker */
/* Use the canonical TEXT_FONTS map (defined at top of file) so the
   summary renders cursive/block/fondant in the SAME font as both the
   picker tiles and the live message input. Previously a separate
   STYLE_FONT map drifted from TEXT_FONTS — picking "Buttercream
   cursive" rendered the message in the block font in the summary. */
var STYLE_FONT = TEXT_FONTS;
set('dhb-sum-size', state.sizeName);
set('dhb-sum-flavor', state.flavor + (state.flavorExtra > 0 ? ' (+$' + state.flavorExtra.toFixed(2) + ')' : ''));
/* Flavor thumb — pull from the flavor card's image if available */
if (state.flavor) {
var flavorCard = document.querySelector('.dhb-flavor-item[data-flavor="' + state.flavor + '"] .dhb-flavor-thumb img');
if (flavorCard && flavorCard.src) setThumbImg('dhb-sum-thumb-flavor', flavorCard.src);
    }
var dp = []; if (state.diet.gf) dp.push('Gluten-Free'); if (state.diet.nut) dp.push('Nut Allergy');
set('dhb-sum-diet', dp.join(' + ') || 'None');
if (cfg.hasPresetColors) {
set('dhb-sum-color', state.presetColor);
/* For preset color combos there's no single hex — leave swatch blank */
    }
else if (cfg.hasColors) {
var cp = []; for (var i = 1; i <= cfg.colorCount; i++) { if (state.colors[i]) cp.push(cfg.colorCount > 1 ? 'Color ' + i + ': ' + state.colors[i] : state.colors[i]); }
set('dhb-sum-color', cp.join(' · '));
/* Single-color cake — render the swatch. Multi-color cakes already
   have a swatch row at the bottom, so skip the inline thumb. */
if (cfg.colorCount === 1 && state.colors[1]) {
var hex = colorHex(state.colors[1]);
setThumbColor('dhb-sum-thumb-color', hex);
      }
    }
if (cfg.hasRibbonColor) {
set('dhb-sum-ribbon', state.ribbonColor);
var rimg = ribbonImage(state.ribbonColor);
if (rimg) setThumbImg('dhb-sum-thumb-ribbon', rimg);
    }
if (cfg.hasPipingColor) {
var pipingRow = document.getElementById('dhb-sum-row-piping');
if (state.pipingExtra > 0 && state.pipingColor) {
set('dhb-sum-piping', state.pipingColor + ' (+$' + (optPrice('Custom piping color') || 5).toFixed(2) + ')');
setThumbColor('dhb-sum-thumb-piping', colorHex(state.pipingColor));
if (pipingRow) pipingRow.removeAttribute('hidden');
      } else if (pipingRow) {
pipingRow.setAttribute('hidden', '');
      }
    }
if (cfg.hasCherries)     set('dhb-sum-cherries',  state.cherry);
if (cfg.hasMessage) {
var sl = { fondant: 'Fondant letters', cursive: 'Buttercream cursive', block: 'Buttercream block', none: 'No text' };
set('dhb-sum-text', sl[state.textStyle] || '—');
/* Render the "Aa" preview in the chosen font */
if (state.textStyle && STYLE_FONT[state.textStyle]) {
setFontStyle('dhb-sum-thumb-text', STYLE_FONT[state.textStyle], '#0c0c0e');
      }
if (state.textStyle && state.textStyle !== 'none') {
var msgVal = state.textStyle === 'fondant' ? [state.msgLine1, state.msgLine2].filter(Boolean).join(' / ') : state.msgText;
set('dhb-sum-msg', msgVal);
/* Letter color resolution */
var letterDisplay, letterHex;
if (cfg.letterColorMatchesColor && state.colors[cfg.letterColorMatchesColor]) {
letterDisplay = 'Matches Color ' + cfg.letterColorMatchesColor + ' (' + state.colors[cfg.letterColorMatchesColor] + ')';
letterHex = colorHex(state.colors[cfg.letterColorMatchesColor]);
        } else if (cfg.hasRibbonColor && state.ribbonColor) {
          letterDisplay = 'Matches ribbon (' + state.ribbonColor + ')';
          letterHex = colorHex(state.ribbonColor);
        } else if (!cfg.hasLetterColors && !cfg.hasComicStyle && cfg.hasColors && state.colors[1]) {
          /* Letters aren't an independent choice on this cake — they take the
             single "Piping & letter color" swatch the customer picked (e.g.
             Cute Sprinkle Sweetheart: white base, only piping + letters take
             the chosen color). Show the match instead of a blank row. */
          letterDisplay = 'Matches piping color (' + state.colors[1] + ')';
          letterHex = colorHex(state.colors[1]);
        } else {
          letterDisplay = state.letterColor;
          letterHex = colorHex(state.letterColor);
        }
set('dhb-sum-letter', letterDisplay);
setThumbColor('dhb-sum-thumb-letter', letterHex);
/* Render message in chosen font + letter color */
var msgEl = document.getElementById('dhb-sum-msg');
if (msgEl) {
msgEl.style.fontFamily = STYLE_FONT[state.textStyle] || '';
msgEl.style.color = letterHex || '';
        }
      }
    }
if (cfg.hasBurnAway) {
set('dhb-sum-burnaway-top', state.burnAwayTop === 'calendar' ? 'Calendar — ' + state.burnMonth + ' ' + state.burnDay : 'Custom image');
set('dhb-sum-reveal', state.revealType === 'image' ? 'Printed image (+$' + state.revealImageUpcharge.toFixed(2) + ')' : 'Fondant message');
/* If the customer uploaded a custom image, show its thumbnail
   (heart-cropped via the photo-thumb mask) */
var burnThumb = document.getElementById('dhb-sum-thumb-burn');
if (burnThumb) {
if (state.burnAwayTop !== 'calendar' && state.burnAwayTopFileNameObjectUrl) {
burnThumb.style.backgroundImage = 'url(' + state.burnAwayTopFileNameObjectUrl + ')';
burnThumb.textContent = '';
        } else {
burnThumb.style.backgroundImage = '';
burnThumb.textContent = '📅';
        }
      }
    }
if (cfg.hasPhotoUpload && !cfg.hasBurnAway) {
set('dhb-sum-photo', state.photoFileName || 'No photo uploaded');
/* Show heart-cropped photo thumbnail using the live object URL */
var photoThumb = document.getElementById('dhb-sum-thumb-photo');
if (photoThumb) {
if (state.photoFileNameObjectUrl) {
photoThumb.style.backgroundImage = 'url(' + state.photoFileNameObjectUrl + ')';
        } else {
photoThumb.style.backgroundImage = '';
        }
      }
    }
/* Sprinkles summary row — show chosen sprinkle name + price suffix */
if (cfg.hasSprinkles) {
var sprinkleDisplay = state.sprinkle.name || '—';
if (state.sprinkle.price > 0) sprinkleDisplay += ' (+$' + state.sprinkle.price.toFixed(2) + ')';
set('dhb-sum-sprinkles', sprinkleDisplay);
    }
/* ── Make it pretty (decoratives) summary row ──
   Lists each selected decorative addon as a comma-separated value.
   Row is hidden if nothing is selected so it doesn't add noise to
   customers who skipped the decoratives step. */
var decoRow = document.getElementById('dhb-sum-row-decoratives');
if (decoRow) {
var decoParts = [];
if (state.extras.addCherries.sel && state.extras.addCherries.type) {
decoParts.push('Cherries — ' + state.extras.addCherries.type);
      }
if (state.extras.addBow.sel) {
decoParts.push(state.extras.addBow.color ? 'Bow — ' + state.extras.addBow.color : 'Bow');
      }
if (state.extras.addGlitter.sel) {
decoParts.push('Iridescent glitter');
      }
if (decoParts.length) {
set('dhb-sum-decoratives', decoParts.join(', '));
decoRow.removeAttribute('hidden');
      } else {
decoRow.setAttribute('hidden', '');
      }
    }
/* ── Missed-candles nudge — show only if no candles selected and user hasn't dismissed ── */
var nudge = document.getElementById('dhb-candle-nudge');
if (nudge && !window.dhbNudgeDismissed) {
var ts = state.addons.candles.types;
var hasCandles = state.addons.candles.sel && (ts.rainbow.active || ts.metallic.active || ts.number.active || ts.sparklers.active);
if (hasCandles) {
nudge.setAttribute('hidden', '');
    } else {
nudge.removeAttribute('hidden');
    }
  }
  }
/* ── Validation (mirrors signature builder) ── */
function validate() {
var errors = [];
if (!state.variantId) { errors.push('Please choose a size.'); }
if (!state.flavor)    { errors.push('Please choose a flavor.'); }
if (state.diet.nut && !state.nutAcked) { errors.push('Please acknowledge the nut allergy notice.'); }
if (state.diet.gf  && !state.gfAcked)  { errors.push('Please acknowledge the gluten notice.'); }
if (cfg.hasColors && !cfg.hasPresetColors) {
for (var i = 1; i <= cfg.colorCount; i++) {
if (!state.colors[i]) { errors.push('Please choose Color ' + i + ' for your cake.'); break; }
      }
    }
if (cfg.hasPresetColors && !state.presetColor) { errors.push('Please choose a color combination.'); }
if (cfg.hasRibbonColor && !state.ribbonColor)  { errors.push('Please choose a ribbon color.'); }
if (cfg.hasCherries   && !state.cherry)        { errors.push('Please choose a cherry option.'); }
if (cfg.hasMessage && !cfg.hasBurnAway && state.textStyle && state.textStyle !== 'none') {
if (state.textStyle === 'fondant' && !state.msgLine1.trim()) { errors.push('Please enter your message (Line 1).'); }
if (state.textStyle !== 'fondant' && !state.msgText.trim())  { errors.push('Please enter your message.'); }
    }
if (cfg.hasBurnAway) {
if (!state.burnAwayTop) { errors.push('Please choose a burn away top option.'); }
if (state.burnAwayTop === 'calendar' && (!state.burnMonth || !state.burnDay)) { errors.push('Please enter the month and day for your calendar.'); }
if (state.revealType === 'fondant' && !state.msgLine1.trim()) { errors.push('Please enter your reveal message.'); }
    }
if (cfg.hasPhotoUpload && !cfg.hasBurnAway && !state.photoFileName) { errors.push('Please upload your photo.'); }
if ((cfg.hasSprinkles || cfg.hasCuteSprinkleStyle) && !state.sprinkle.key) { errors.push('Please choose a sprinkle option.'); }
if (state.addons.candles.sel) {
var ts = state.addons.candles.types;
var anyActive = ts.rainbow.active || ts.metallic.active || ts.number.active || ts.sparklers.active;
if (!anyActive) {
errors.push('Please choose at least one candle type.');
      } else {
if (ts.metallic.active && !ts.metallic.color) errors.push('Please choose a color for your metallic candles.');
if (ts.number.active   && !ts.number.color)   errors.push('Please choose a color for your number candles.');
if (ts.number.active   && !ts.number.number)  errors.push('Please enter the number for your number candles.');
      }
    }
/* Decoratives — bow needs a color, cherries needs a type */
if (state.extras.addBow.sel && !state.extras.addBow.color) {
errors.push('Please choose a color for your bow.');
    }
if (state.extras.addCherries.sel && !state.extras.addCherries.type) {
errors.push('Please choose a cherry style.');
    }
/* Custom piping color — needs an actual color picked, not just toggled on */
if (state.pipingExtra > 0 && !state.pipingColor) {
errors.push('Please choose a piping color.');
    }
return errors;
  }
/* ── Cart ── */
function syncVariantInput() { var i = document.getElementById('dhb-variant-id'); if (i) i.value = state.variantId; }
function buildProperties() {
var p = {};
p['Flavor'] = state.flavor + (state.flavorExtra > 0 ? ' (+$' + state.flavorExtra.toFixed(2) + ')' : '');
var dp = []; if (state.diet.gf) dp.push('Gluten-Free (+$' + glutenFreePrice().toFixed(2) + ')'); if (state.diet.nut) dp.push('Nut Allergy (acknowledged)');
if (dp.length) p['Dietary'] = dp.join(' + ');
if (cfg.hasPresetColors) { p['Color'] = state.presetColor; }
else if (cfg.hasColors) {
for (var i = 1; i <= cfg.colorCount; i++) { if (state.colors[i]) p[cfg.colorCount > 1 ? 'Color ' + i : 'Buttercream color'] = state.colors[i]; }
var cs = Object.keys(state.customColorPrices).filter(function(k) { return state.customColorPrices[k] > 0; });
if (cs.length) p['Custom color fee'] = '+$' + cs.reduce(function(s,k) { return s + state.customColorPrices[k]; }, 0).toFixed(2);
    }
if (cfg.hasRibbonColor && state.ribbonColor) {
p['Ribbon color'] = state.ribbonColor;
p['Letter color'] = state.ribbonColor + ' (matches ribbon)';
    }
if (cfg.hasCherries && state.cherry) p['Cherries'] = state.cherry + (state.cherryPrice > 0 ? ' (+$' + state.cherryPrice.toFixed(2) + ')' : '');
if (state.pipingColor) p['Custom piping color'] = state.pipingColor + ' (+$' + (optPrice('Custom piping color') || 5).toFixed(2) + ')';
if (cfg.hasMessage && state.textStyle) {
if (state.textStyle === 'none') { p['Text'] = 'No text'; }
else {
var sl = { fondant: 'Fondant letters', cursive: 'Buttercream cursive', block: 'Buttercream block' };
p['Text style'] = sl[state.textStyle];
if (state.textStyle === 'fondant') { if (state.msgLine1) p['Message line 1'] = state.msgLine1; if (state.msgLine2) p['Message line 2'] = state.msgLine2; }
else { if (state.msgText) p['Message'] = state.msgText; }
if (state.letterColor) p['Letter color'] = state.letterColor;
else if (!cfg.hasLetterColors && !cfg.hasComicStyle && !cfg.hasRibbonColor && !cfg.letterColorMatchesColor && cfg.hasColors && state.colors[1]) p['Letter color'] = state.colors[1] + ' (matches piping color)';        if (state.customLetterPrice > 0) p['Custom letter color fee'] = '+$' + (optPrice('Custom letter color') || 5).toFixed(2);
      }
    } else if (cfg.letterColorMatchesColor && state.colors[cfg.letterColorMatchesColor]) {
p['Letter color'] = state.colors[cfg.letterColorMatchesColor] + ' (matches Color ' + cfg.letterColorMatchesColor + ')';
    }
if (cfg.hasBurnAway) {
if (state.burnAwayTop === 'image') {
var topMsg = 'Custom image: ' + (state.burnAwayTopFileName || 'uploaded');
if (state.burnAwayTopUrl) topMsg = state.burnAwayTopUrl;
p['Burn away top'] = topMsg;
if (state.burnAwayTopUrl)            p['Burn away top photo'] = state.burnAwayTopUrl;
if (state.burnAwayTopFileNameCropData) {
var topC = state.burnAwayTopFileNameCropData;
p['Burn away top crop'] = 'x:' + topC.x + ' y:' + topC.y + ' w:' + topC.width + ' h:' + topC.height;
        }
      } else {
p['Burn away top'] = 'Calendar — Month: ' + state.burnMonth + ', Day: ' + state.burnDay;
      }
if (state.revealType === 'image') {
var revMsg = 'Printed image (+$' + state.revealImageUpcharge.toFixed(2) + ') — ' + (state.revealImageName || 'uploaded');
if (state.revealImageUrl) revMsg = 'Printed image (+$' + state.revealImageUpcharge.toFixed(2) + ') — ' + state.revealImageUrl;
p['Reveal'] = revMsg;
if (state.revealImageUrl)             p['Reveal photo'] = state.revealImageUrl;
if (state.revealImageNameCropData) {
var revC = state.revealImageNameCropData;
p['Reveal crop'] = 'x:' + revC.x + ' y:' + revC.y + ' w:' + revC.width + ' h:' + revC.height;
        }
      } else {
p['Reveal'] = 'Fondant message: ' + ([state.msgLine1, state.msgLine2].filter(Boolean).join(' / '));
      }
    }
if (cfg.hasPhotoUpload && !cfg.hasBurnAway && state.photoFileName) {
p['Photo'] = state.photoUrl ? state.photoUrl : state.photoFileName;
if (state.photoUrl) p['Photo url'] = state.photoUrl;
if (state.photoFileNameCropData) {
var phC = state.photoFileNameCropData;
p['Photo crop'] = 'x:' + phC.x + ' y:' + phC.y + ' w:' + phC.width + ' h:' + phC.height;
      }
    }
if (cfg.hasPearlColorChoice && state.pearlChoice) p['Pearl color'] = state.pearlChoice;
if (cfg.hasDecorationColor && state.decoColor) p['Decoration color'] = state.decoColor;
if (cfg.hasSprinkles && state.sprinkle.name) {
p['Sprinkles'] = state.sprinkle.name + (state.sprinkle.price > 0 ? ' (+$' + state.sprinkle.price.toFixed(2) + ')' : '');
    }
if (state.addons.candles.sel) {
var ts = state.addons.candles.types;
var parts = [];
if (ts.rainbow.active)   parts.push('Rainbow');
if (ts.metallic.active)  parts.push(ts.metallic.color ? 'Metallic — ' + ts.metallic.color : 'Metallic');
if (ts.number.active) {
var npart = 'Number';
if (ts.number.color) npart += ' — ' + ts.number.color;
if (ts.number.number) npart += ' (' + ts.number.number + ')';
parts.push(npart);
      }
if (ts.sparklers.active) parts.push('Sparklers');
if (parts.length) p['Candles'] = parts.join(' + ');
    }
if (state.addons.gift.text && state.addons.gift.text.trim()) p['Gift message'] = state.addons.gift.text;
if (state.extras.bow.sel)      p['XL Gold Bow']   = 'Yes';
if (state.extras.server.sel)   p['Cake server']   = 'Yes';
if (state.extras.coldpack.sel) p['Gel cold pack'] = 'Yes';
if (state.extras.addCherries.sel && state.extras.addCherries.type) p['Add cherries'] = state.extras.addCherries.type + ' (+$' + state.extras.addCherries.price.toFixed(2) + ')';
if (state.extras.addBow.sel && state.extras.addBow.color) {
var bowP = optPrice('Add bows') || 10;
p['Add bow'] = state.extras.addBow.color + ' ribbon (+$' + bowP.toFixed(2) + ')';
    }
if (state.extras.addGlitter.sel) {
var glitP = optPrice('Add iridescent glitter') || 20;
p['Add iridescent glitter'] = 'Yes (+$' + glitP.toFixed(2) + ')';
    }
return p;
  }
function buildAddonItems(cakeKey) {
var items = []; 
var tag = cakeKey ? { '_addon_for': cakeKey } : {};
var OPT = window.dhbOptionVariants || {};
var CAN = window.dhbCandleVariants || {};
var MET = window.dhbMetallicVariants || {};
/* Flavor upcharge */
if (state.flavorExtra > 0 && window.dhbFlavorVariants) {
var fvid = window.dhbFlavorVariants[state.flavor];
if (fvid) items.push({ id: fvid, quantity: 1, properties: Object.assign({}, tag) });
    }
/* Gluten free */
if (state.diet.gf) items.push({ id: VARIANT_IDS.glutenFree, quantity: 1, properties: Object.assign({}, tag) });
/* Custom color +$10 per slot */
var customColorCount = Object.keys(state.customColorPrices).filter(function(k) { return state.customColorPrices[k] > 0; }).length;
if (customColorCount > 0 && OPT['Custom color']) {
items.push({ id: OPT['Custom color'], quantity: customColorCount, properties: Object.assign({}, tag) });
    }
/* Custom letter color +$5 */
if (state.customLetterPrice > 0 && OPT['Custom letter color']) {
items.push({ id: OPT['Custom letter color'], quantity: 1, properties: Object.assign({}, tag) });
    }
/* Custom piping color +$5 */
if (state.pipingExtra > 0) {
if (OPT['Custom piping color']) {
items.push({ id: OPT['Custom piping color'], quantity: 1, properties: Object.assign({}, tag) });
      } else {
dwarn('[dhb] Custom piping color variant not found in OPT — piping upcharge NOT added to cart. Available:', Object.keys(OPT));
      }
    }
/* Candles — push one line item per active type. With multi-select,
   the customer can have Rainbow + Sparklers + Metallic Gold all in
   their cart at once (each as its own line item, each charged in full). */
if (state.addons.candles.sel) {
var ts = state.addons.candles.types;
if (ts.rainbow.active) {
items.push({ id: VARIANT_IDS.rainbowCandles, quantity: 1, properties: Object.assign({}, tag) });
      }
if (ts.sparklers.active) {
items.push({ id: VARIANT_IDS.sparklers, quantity: 1, properties: Object.assign({}, tag) });
      }
if (ts.metallic.active && ts.metallic.color) {
var mid = MET[ts.metallic.color];
if (mid) items.push({ id: mid, quantity: 1, properties: Object.assign({}, tag) });
else dwarn('dhb: metallic candle variant not found for color:', ts.metallic.color, 'available:', Object.keys(MET));
      }
if (ts.number.active && ts.number.color) {
var nid = CAN[ts.number.color];
var numDigits = ts.number.number ? String(ts.number.number).replace(/\D/g, '').length : 1;
if (nid) items.push({ id: nid, quantity: numDigits, properties: Object.assign({ 'Number': ts.number.number }, tag) });
else dwarn('dhb: number candle variant not found for color:', ts.number.color, 'available:', Object.keys(CAN));
      }
    }
/* Built-in cherries upcharge (metallic upgrade only — $10).
   Uses dedicated 'Cherry upgrade — Metallic' variant ($10) instead of
   the 'Add cherries — Metallic' variant ($20), which is reserved for
   the add-on path where it represents $10 base + $10 metallic delta.
   Prevents builder/cart mismatch on cakes with built-in cherries
   (Classy Sweetheart, Coquette, etc.). */
if (cfg.hasCherries && state.cherryPrice > 0) {
if (OPT['Cherry upgrade — Metallic']) items.push({ id: OPT['Cherry upgrade — Metallic'], quantity: 1, properties: Object.assign({}, tag) });
else dwarn('dhb: Cherry upgrade — Metallic variant not found in OPT — built-in cherry upgrade not pushed to cart');
    }
/* Add-on cherries */
if (state.extras.addCherries.sel && state.extras.addCherries.type) {
var addCherryVar = state.extras.addCherries.price >= 20 ? 'Add cherries — Metallic' : 'Add cherries — Fake or Maraschino';
if (OPT[addCherryVar]) items.push({ id: OPT[addCherryVar], quantity: 1, properties: Object.assign({}, tag) });
    }
/* Add-on bow +$10 */
if (state.extras.addBow.sel && OPT['Add bows']) {
items.push({ id: OPT['Add bows'], quantity: 1, properties: Object.assign({}, tag) });
    }
/* Add-on glitter +$20 */
if (state.extras.addGlitter.sel && OPT['Add iridescent glitter']) {
items.push({ id: OPT['Add iridescent glitter'], quantity: 1, properties: Object.assign({}, tag) });
    }
/* Burn away reveal image +$20 */
if (cfg.hasBurnAway && state.revealType === 'image' && OPT['Burn away reveal image']) {
items.push({ id: OPT['Burn away reveal image'], quantity: 1, properties: Object.assign({}, tag) });
    }
/* Sprinkles — only paid options need a cart line item. Free sprinkle
   choices (Rainbow, Confetti, etc.) just need the property in cake
   notes, no additional charge. Mirrors designer-builder pattern with
   multiple candidate titles for the variant lookup. */
if (cfg.hasSprinkles && state.sprinkle.price > 0 && state.sprinkle.name) {
var sprinkleCandidates = [
'Sprinkles — ' + state.sprinkle.name,
'Sprinkles - ' + state.sprinkle.name,
state.sprinkle.name,
'Sprinkle upgrade'
      ];
var sprinkleId = null, matchedTitle = null;
for (var si = 0; si < sprinkleCandidates.length; si++) {
if (OPT[sprinkleCandidates[si]]) {
sprinkleId = OPT[sprinkleCandidates[si]];
matchedTitle = sprinkleCandidates[si];
break;
        }
      }
if (sprinkleId) {
var sprinkleQty = matchedTitle === 'Sprinkle upgrade' ? Math.round(state.sprinkle.price) : 1;
items.push({ id: sprinkleId, quantity: sprinkleQty, properties: Object.assign({}, tag) });
      } else {
dwarn('[dhb] Sprinkle variant not found — tried:', sprinkleCandidates, '— available:', Object.keys(OPT));
      }
    }
/* Standard extras */
if (state.extras.bow.sel)      items.push({ id: VARIANT_IDS.bow,        quantity: 1, properties: Object.assign({}, tag) });
if (state.extras.server.sel)   items.push({ id: VARIANT_IDS.cakeServer, quantity: 1, properties: Object.assign({}, tag) });
if (state.extras.coldpack.sel) items.push({ id: VARIANT_IDS.coldPack,   quantity: 1, properties: Object.assign({}, tag) });
return items;
  }
function submitCart() {
if (!state.variantId) return;
var errors = validate();
if (errors.length) { showCartError(errors[0]); return; }
var btn = document.getElementById('dhb-btn-atc');
if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
/* If burn-away cake with images, capture canvases first, upload to
   Cloudinary, then build cart properties so the URL is included. */
captureAndUploadImages(btn).then(function () {
fetch('/cart/add.js', {
method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: [{ id: parseInt(state.variantId), quantity: 1, properties: buildProperties() }] })
      }).then(function(r) { return r.json(); })
      .then(function(data) {
if (data.status) { if (btn) { btn.textContent = 'Add to cart'; btn.disabled = false; } showCartError('Something went wrong: ' + (data.description || 'Please try again.')); return; }
var cakeKey = data.items && data.items[0] && data.items[0].key ? data.items[0].key : null;
var addons  = buildAddonItems(cakeKey);
if (!addons.length) { onCartSuccess(btn); return; }
return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: addons }) })
          .then(function() { onCartSuccess(btn); });
      }).catch(function(err) {
console.error('dhb cart error:', err);
showCartError('We couldn\'t reach the cart. Check your connection and try again.');
if (btn) { btn.textContent = 'Add to cart'; btn.disabled = false; }
      });
    });
  }
/* ── Capture cropped canvases, mask them to a heart, and upload to
   Cloudinary. Runs at add-to-cart time (not on every drag) so we
   don't burn through Cloudinary quota on builds that get abandoned.
   Each upload races against an 8-second timeout — if Cloudinary is
   slow we proceed without the URL rather than block checkout. */
function captureAndUploadImages(btn) {
var jobs = [];
if (cfg.hasBurnAway) {
if (state.burnAwayTop === 'image' && state.burnAwayTopCropper && state.burnAwayTopFileName) {
jobs.push(captureAndUpload('burnAwayTop', state.burnAwayTopCropper, btn));
      }
if (state.revealType === 'image' && state.revealImageCropper && state.revealImageName) {
jobs.push(captureAndUpload('revealImage', state.revealImageCropper, btn));
      }
    }
if (cfg.hasPhotoUpload && !cfg.hasBurnAway && state.photoCropper && state.photoFileName) {
jobs.push(captureAndUpload('photo', state.photoCropper, btn));
    }
var raws = [];
if (state.photoUrlRawPromise)       raws.push(state.photoUrlRawPromise);
if (state.burnAwayTopUrlRawPromise) raws.push(state.burnAwayTopUrlRawPromise);
if (state.revealImageUrlRawPromise) raws.push(state.revealImageUrlRawPromise);
if (!jobs.length && !raws.length) return Promise.resolve();
if (btn) btn.textContent = 'Uploading photos…';
return Promise.all(jobs.concat(raws));
  }
function captureAndUpload(prefix, cropper, btn) {
return new Promise(function (resolve) {
var squareCanvas;
try {
squareCanvas = cropper.getCroppedCanvas({
maxWidth:  1200,
maxHeight: 1200,
imageSmoothingEnabled: true,
imageSmoothingQuality: 'high'
        });
      } catch (e) {
dwarn('[dhb] getCroppedCanvas threw for ' + prefix + ':', e);
return resolve(null);
      }
if (!squareCanvas) return resolve(null);
/* Mask the square crop to a heart shape so the PNG that uploads
   already shows the customer's exact heart preview. The bakery
   sees the file as a heart, not a square. */
var size = Math.min(squareCanvas.width, squareCanvas.height);
var heart = document.createElement('canvas');
heart.width  = size;
heart.height = size;
var ctx = heart.getContext('2d');
drawHeartPath(ctx, size, size);
ctx.clip();
var dx = (size - squareCanvas.width)  / 2;
var dy = (size - squareCanvas.height) / 2;
ctx.drawImage(squareCanvas, dx, dy);
var upload = new Promise(function (res, rej) {
heart.toBlob(function (blob) {
if (!blob) return rej(new Error('Blob conversion returned null'));
var form = new FormData();
form.append('file',          blob, prefix + '-heart.png');
form.append('upload_preset', CLOUDINARY_PRESET);
fetch(CLOUDINARY_URL, { method: 'POST', body: form })
          .then(function (r) { if (!r.ok) throw new Error('Cloudinary HTTP ' + r.status); return r.json(); })
          .then(function (data) {
if (!data || !data.secure_url) return rej(new Error('No URL returned'));
state[prefix + 'Url'] = data.secure_url;
res(data);
          })
          .catch(rej);
        }, 'image/png');
      });
var timeout = new Promise(function (res) {
setTimeout(function () {
dwarn('[dhb] Upload timeout (8s) for ' + prefix + ' — proceeding without URL');
res(null);
        }, 8000);
      });
Promise.race([upload, timeout])
        .catch(function (err) { dwarn('[dhb] Upload error for ' + prefix + ':', err && err.message); })
        .then(resolve);
    });
  }
/* Heart-shaped path on a canvas context, sized to fill (w × h).
   Mirrors the SVG path used in the visual mask — same proportions. */
function drawHeartPath(ctx, w, h) {
ctx.beginPath();
ctx.moveTo(w * 0.5,   h * 1.0);
ctx.bezierCurveTo(w * 0.5,   h * 1.0,   w * 0.0,   h * 0.7,   w * 0.0,   h * 0.3);
ctx.bezierCurveTo(w * 0.0,   h * 0.135, w * 0.135, h * 0.0,   w * 0.275, h * 0.0);
ctx.bezierCurveTo(w * 0.39,  h * 0.0,   w * 0.5,   h * 0.1,   w * 0.5,   h * 0.25);
ctx.bezierCurveTo(w * 0.5,   h * 0.1,   w * 0.61,  h * 0.0,   w * 0.725, h * 0.0);
ctx.bezierCurveTo(w * 0.865, h * 0.0,   w * 1.0,   h * 0.135, w * 1.0,   h * 0.3);
ctx.bezierCurveTo(w * 1.0,   h * 0.7,   w * 0.5,   h * 1.0,   w * 0.5,   h * 1.0);
ctx.closePath();
  }
function onCartSuccess(btn) {
if (btn) btn.textContent = 'Added! ✓';
setTimeout(function() { if (btn) { btn.textContent = 'Add to cart'; btn.disabled = false; } }, 2000);
fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
var n = 0; cart.items.forEach(function(item) { var a = item.properties && Object.keys(item.properties).some(function(k) { return k === '_addon_for'; }); if (!a) n += item.quantity; });
document.querySelectorAll('.dbn-cart-badge').forEach(function(el) { el.textContent = n; el.style.display = n > 0 ? '' : 'none'; });
document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    }).catch(function() { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); });
  }
})();
/* ── Cart badge polling ── */
(function () {
function refreshBadge() {
fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
var n = 0; cart.items.forEach(function(item) { var a = item.properties && Object.keys(item.properties).some(function(k) { return k === '_addon_for'; }); if (!a) n += item.quantity; });
document.querySelectorAll('.dbn-cart-badge').forEach(function(el) { el.textContent = n; el.style.display = n > 0 ? '' : 'none'; });
    }).catch(function() {});
  }
if (document.readyState === 'complete') refreshBadge();
else window.addEventListener('load', refreshBadge);
document.addEventListener('cart:change',  refreshBadge);
document.addEventListener('cart:refresh', refreshBadge);
setInterval(refreshBadge, 2000);
}());

/* ────────────────────────────────────────────────────────────────────────────
   Chat-widget opener for "contact us" links inside allergy notices and the
   "Tell us in the chat" invitation. Tries each major chat widget API in
   priority order. Falls back to /pages/contact if no widget is detected.
   Works with Tidio, Gorgias, Crisp, Shopify Inbox, Intercom, Drift, LiveChat.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  function openChatWidget(context) {
    // Tidio
    if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
      window.tidioChatApi.open();
      if (context && typeof window.tidioChatApi.messageFromVisitor === 'function') {
        try { window.tidioChatApi.messageFromVisitor('Question about ' + context); } catch (e) {}
      }
      return true;
    }
    // Gorgias
    if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
      window.GorgiasChat.open();
      return true;
    }
    // Crisp
    if (window.$crisp && typeof window.$crisp.push === 'function') {
      window.$crisp.push(['do', 'chat:open']);
      return true;
    }
    // Shopify Inbox
    if (window.ShopifyChat && typeof window.ShopifyChat.open === 'function') {
      window.ShopifyChat.open();
      return true;
    }
    // Intercom
    if (typeof window.Intercom === 'function') {
      window.Intercom('show');
      return true;
    }
    // Drift
    if (window.drift && typeof window.drift.api === 'object' && typeof window.drift.api.openChat === 'function') {
      window.drift.api.openChat();
      return true;
    }
    // LiveChat
    if (window.LC_API && typeof window.LC_API.open_chat_window === 'function') {
      window.LC_API.open_chat_window();
      return true;
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.dhb-open-chat');
    if (!trigger) return;
    e.preventDefault();
    var context = trigger.getAttribute('data-chat-context') || '';
    var opened = openChatWidget(context);
    if (!opened) {
      // Fallback: navigate to contact page
      window.location.href = '/pages/contact';
    }
  });
})();

/* ────────────────────────────────────────────────────────────────────────────
   "See how colors look on real cakes" — accordion toggle for color reference.
   Uses [hidden] attribute + aria-expanded to keep semantics clean.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('.dhb-color-guide-toggle');
    if (!toggle) return;
    var panelId = toggle.getAttribute('aria-controls');
    if (!panelId) return;
    var panel = document.getElementById(panelId);
    if (!panel) return;
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    if (isOpen) panel.setAttribute('hidden', '');
    else panel.removeAttribute('hidden');
  });
})();